<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [
            {
              "num_cand": "U2FsdGVkX19GqqpgNVpVX9R+lpqCqcY/UXpw2UGKG5E=",
              "cpf": "U2FsdGVkX1+qNCQX2Hpjpkp0xGXcZOqFEaWpsOG55Zk="
            }, {
            "num_cand": "U2FsdGVkX1+hvKujFIP/O+aZOM7ULGWvuB4TcS27IOY=",
            "cpf": "U2FsdGVkX18JAKl2BxdqMipcpfCXyDamo12iY9VsnEA="
          }, {
            "num_cand": "U2FsdGVkX1/lsphp7VhbcZvtx3DY8uJC3b0sIRUhnsU=",
            "cpf": "U2FsdGVkX181xYuVodDYShA54PAV1jB0gt+86A9ERCQ="
          }, {
            "num_cand": "U2FsdGVkX19XH9ogj4SuYL+kHKonXHbQwvl1zOG3gUQ=",
            "cpf": "U2FsdGVkX1+zpJIhyREAuJBvCp2L4nJgIaaDTZ86vvI="
          }, {
            "num_cand": "U2FsdGVkX1/JkbhN0UuUYdrnHH13xHhlcrWMhEJ86hk=",
            "cpf": "U2FsdGVkX18qMJuYty7XsYI/lBhoS1NwfYwXt9uaE78="
          }, {
            "num_cand": "U2FsdGVkX187zED6cfPJbA9tV779RXmAVK96ldBnHzE=",
            "cpf": "U2FsdGVkX18XJA27mog1ruNCCicmpyAioI48u4nPWck="
          }, {
            "num_cand": "U2FsdGVkX183a+rm1PVdT8LQj23Dv2EqWi+igzNjY6M=",
            "cpf": "U2FsdGVkX1+gcmvfgtQUb2uIvwFN/VYh35Sx9pyTlgA="
          }, {
            "num_cand": "U2FsdGVkX18WpNlTtuSaZ3lax6rpF7NrPZprvmUdmIc=",
            "cpf": "U2FsdGVkX1/z8hxEZz6KC8PcPEkH9o/qpVwMNEacU1s="
          }, {
            "num_cand": "U2FsdGVkX19KZi2PZKVSio5LsSUjWY8BO/ofAimAYPE=",
            "cpf": "U2FsdGVkX1+m1LVShQ0D6b6zzK7RvQshn7TVy324Eb8="
          }, {
            "num_cand": "U2FsdGVkX18V+5VGtBJDegmnbP3ZiWSVvo1/QgsRdZQ=",
            "cpf": "U2FsdGVkX199T1rMXjUirZlz0dXlyOy4ytNaXgLWCH4="
          }, {
            "num_cand": "U2FsdGVkX1+U1bzCJwpL+uM03had8SQtnw2dKJPtkKI=",
            "cpf": "U2FsdGVkX18d2LDT35I3qLNtMGXIIjBl6O/0+prCVyg="
          }, {
            "num_cand": "U2FsdGVkX1/20WF7p6MG6zfR1fm8Pxix8fm+cSV+VD8=",
            "cpf": "U2FsdGVkX1/UhbTOzLvwHxOPjv1wAZN8j9mqw2R0rIw="
          }, {
            "num_cand": "U2FsdGVkX18l0bMexi3TPvhmR1gFMsSpBvPwrxg06zo=",
            "cpf": "U2FsdGVkX18Vy8peu7J5kb6d968lZY4Bt8C7vFvqilE="
          }, {
            "num_cand": "U2FsdGVkX18HxsE3qLGSuN5LeivuOQ4Fkuk9zEIp2MU=",
            "cpf": "U2FsdGVkX18GeHtpdfYIXTrJxqW4YYTk1oEYdIppHgU="
          }, {
            "num_cand": "U2FsdGVkX19iZuuaCjWGkvo6UAT1JxdT/jaCzqFD2Uk=",
            "cpf": "U2FsdGVkX19qDXrhscdwIwl9qloQsdiIoEf/oLlrvFA="
          }, {
            "num_cand": "U2FsdGVkX1+i48O3FQGQGWbSxRpz9UYJH4XQEp1CImI=",
            "cpf": "U2FsdGVkX19oEXJtRp+4f1khJr6xTwdGU8eM0fxYwDc="
          }, {
            "num_cand": "U2FsdGVkX1+81MdDQ6PmirK8edymPRyHgjhhTH6JiOI=",
            "cpf": "U2FsdGVkX1/AlZmi7AGEme/wGWW97GUkQt6ZJfHe4rM="
          }, {
            "num_cand": "U2FsdGVkX1+liQAcH3trDELeanIomN1MmiynvihKoeM=",
            "cpf": "U2FsdGVkX1/rjcs3dy5cHc8j7RNH982fLgoRCbZnqaQ="
          }, {
            "num_cand": "U2FsdGVkX18S2wfBJ0P89g8mH+aoGHjq6VSoNKnqjyI=",
            "cpf": "U2FsdGVkX1/HMg6JGqC3jZ8thtka6FEttixmj0wb0t0="
          }, {
            "num_cand": "U2FsdGVkX1/0ezrNYh4J+9hqnE41sqb1hS5XUAxX6Mo=",
            "cpf": "U2FsdGVkX1+HvdUxwBt0WKpWruqHPPrJ8H1BUGHuMzA="
          }, {
            "num_cand": "U2FsdGVkX19Bg5nEjeoIOfZC11JKGhMzn6a0TcC9/SU=",
            "cpf": "U2FsdGVkX1+z9kRhT6qxmzdbia+Rjyem81D/HBP2zmQ="
          }, {
            "num_cand": "U2FsdGVkX1+WG4rh3sS0ewvNgA5XIKX5rutkU9frhlQ=",
            "cpf": "U2FsdGVkX18x8s25ISl2+cKO/+w+HYLVyQoJrPQSX5I="
          }, {
            "num_cand": "U2FsdGVkX19lz3ZKgzZX5tT4ayQkWVenZaZ8ijSQejU=",
            "cpf": "U2FsdGVkX1+Y5H0y57PRwq6smW+uSuBckjU/lguCBpo="
          }, {
            "num_cand": "U2FsdGVkX19bPkvvNk8T8t13V7B+s+H4oXEiTjVUaTA=",
            "cpf": "U2FsdGVkX1/AoERG1UUeE3GtPG1fRG4NNSzlw6ERDkc="
          }, {
            "num_cand": "U2FsdGVkX1+IEe+rQpwrRoUfeeIYWBhp0bDxnuQgGTM=",
            "cpf": "U2FsdGVkX1+yVUKML1uGD+3y4dWgokeTOgom4G9TpQc="
          }, {
            "num_cand": "U2FsdGVkX1+OWWX2rM65SA1DUZsmo5LdL6QeaWYB1fc=",
            "cpf": "U2FsdGVkX19TDzbpDBEFKIiHt9l/JpSEhAjZDC39py8="
          }, {
            "num_cand": "U2FsdGVkX18iHqOMlKNVm7N4OSAtf3KwESy+UU6DUBU=",
            "cpf": "U2FsdGVkX1/hLa2J5Blwp9Lmpw4wc0+FyLbe1hID6PU="
          }, {
            "num_cand": "U2FsdGVkX18R8ptioS7e18vz9EXPHZMD5iGyACFOYUk=",
            "cpf": "U2FsdGVkX1/SBU/gomYNpfM3sA0IBGESb1oWkcnO2t4="
          }, {
            "num_cand": "U2FsdGVkX18WjyPbKaFib233kRz4590ei0phpebrVoA=",
            "cpf": "U2FsdGVkX1+/Y0QTY6k5VkVB95hXcnwUnRWN6e67nlA="
          }, {
            "num_cand": "U2FsdGVkX1/4U2E+j0GHfj+NgeoE668NN8C2x38+zAA=",
            "cpf": "U2FsdGVkX1/V+7doECGUAJuD8iEvrcziXYfCmw9GE7s="
          }, {
            "num_cand": "U2FsdGVkX1+4HGkVpNZidQ45xf5pqeF/Q2tGJxHtC8Y=",
            "cpf": "U2FsdGVkX19dbxLD8gyyv9VGU/jV1iNIZD6VktoXco8="
          }, {
            "num_cand": "U2FsdGVkX1++FS7gQXvGJAV9/XoPBHs0j7E6JaCZh/Y=",
            "cpf": "U2FsdGVkX18tbeDqpC3Avp0YoHQN1Kt1c4HJYrH2NkU="
          }, {
            "num_cand": "U2FsdGVkX1+IHsyEGFoXvYXaRifG/Hx/9vbc3Ab1wfY=",
            "cpf": "U2FsdGVkX1/IQHpey5drJAYr/Lc0pLsoEbWfjO4kVC8="
          }, {
            "num_cand": "U2FsdGVkX1/6SUXhrUzBS5Uo0JIOS8VwBDWOhkgqMqk=",
            "cpf": "U2FsdGVkX18eGimTdHCfHMV8aFQoEdEgTqQZ49wW3GE="
          }, {
            "num_cand": "U2FsdGVkX1+AfoSOuW1Yz7IsMDQTJzf5dglExnBA63k=",
            "cpf": "U2FsdGVkX1/63hSelo4LjVLKO6Bh3o14etb65l+bNqI="
          }, {
            "num_cand": "U2FsdGVkX19Q7X7OQ1RaEwosVjpvHWcpk6jKoAOpCfA=",
            "cpf": "U2FsdGVkX1/KbVsawqbEcni9RtMv4Gj3dRVMQxQZuNk="
          }, {
            "num_cand": "U2FsdGVkX18Xc0WjzKapsbWY+KSGXQLpjrZcUq2e+bI=",
            "cpf": "U2FsdGVkX1/Z2IddfWDU9IYC5Ec7+G0QC8G2P+XGZvM="
          }, {
            "num_cand": "U2FsdGVkX18I08l8WCJg0XP3eg3pD5ckqt999pMoZYQ=",
            "cpf": "U2FsdGVkX1/7Rh9BKanpkGF6W/DiojBhHQogZbDAvAo="
          }, {
            "num_cand": "U2FsdGVkX18dgAAwmwIptVqqhRpAX9GnlyN+yGbCMjI=",
            "cpf": "U2FsdGVkX1+7gbuWX2ySVUZFC3nHPcqcSsQXtIYlDoo="
          }, {
            "num_cand": "U2FsdGVkX1/EE43z3md0IjZU3ksdhS0wceKK2AKscaw=",
            "cpf": "U2FsdGVkX1/aqYDw36Vc6tjiQ4D7hBYUuUNyNJHvBIs="
          }, {
            "num_cand": "U2FsdGVkX1/cQQa/Fp0qZAzU5DFe27Jdf6wx97TRbN4=",
            "cpf": "U2FsdGVkX19e8RxOacC0TzuZJ4HeVH/XgWGzar6yAVI="
          }, {
            "num_cand": "U2FsdGVkX18buRGCwr0Rk1CZuRP4wmjgMVj7V6pArNU=",
            "cpf": "U2FsdGVkX1/7RWoMLH5Tks6lP5beCLFdzma5Hc8dJ6k="
          }, {
            "num_cand": "U2FsdGVkX1/ywmOjGfrjgZCaR/feUr7P5fuRFbutV3Y=",
            "cpf": "U2FsdGVkX1+hZAh03PRyFfxtqROR5ogK3/umPQcgauY="
          }, {
            "num_cand": "U2FsdGVkX1+UBJoihCafXvzeHvyndacV6yv+Qq2FugA=",
            "cpf": "U2FsdGVkX1+GI2BHt9AIUgY/S8FDg3Ev7kLDT/gY6ns="
          }, {
            "num_cand": "U2FsdGVkX1+nvLwcag1hVw4yvuATDdGn1xseNgvDJQI=",
            "cpf": "U2FsdGVkX1+7m7bMXrb6kqc6aK3EX8DjwfOvoUg9iuQ="
          }, {
            "num_cand": "U2FsdGVkX18sxT3tZGrucaVinc8ogcwnWmozSbVKGGs=",
            "cpf": "U2FsdGVkX1+Nki2R2W0sdftY3QjyhcBSkH6EQNk0Au8="
          }, {
            "num_cand": "U2FsdGVkX1+1VYCH6vTfJ2vaZLV8U8n6BHrvlRWVkVI=",
            "cpf": "U2FsdGVkX1/p9b3qTQ/cFCN4SGtgw99XNwpjpMVsV7A="
          }, {
            "num_cand": "U2FsdGVkX1+E1srVZsd9hQKhoo77Dq4U0P9tSZvxLOw=",
            "cpf": "U2FsdGVkX19qKBBFguzCJ/p/8rEr8dSM8WBENO2fvHo="
          }, {
            "num_cand": "U2FsdGVkX18HN9NswNkntKHi5iKS2ZtZgWPKmZKvDCU=",
            "cpf": "U2FsdGVkX1+YXuEN4GAHb7qZIw+Lh37sl6UTuqG/NDQ="
          }, {
            "num_cand": "U2FsdGVkX1+BtoVi6d1CgvUpCyCYHUVH70JmfydE0Yg=",
            "cpf": "U2FsdGVkX19qqiEIx/OmeY5c2u4nzDeGplTlXrz98dg="
          }, {
            "num_cand": "U2FsdGVkX196blGdjZOLE/0aHJvzFltmpu59eir56Fs=",
            "cpf": "U2FsdGVkX1+5wVRciQ4ncunGIlorFi0AFopCxX4YPEY="
          }, {
            "num_cand": "U2FsdGVkX1+j/Xg/2VJCQWzu8gR6uigkbTyO+wjQWX4=",
            "cpf": "U2FsdGVkX18ZBUxj30Hi1Fx1dX9r0vfXtr0pHf/0nac="
          }, {
            "num_cand": "U2FsdGVkX19Hw/PQU3BO1gqK3BWdrGTbFjrugmXG2M0=",
            "cpf": "U2FsdGVkX18UJA8prHKZvkULBwboaP1h5alEw42nBxw="
          }, {
            "num_cand": "U2FsdGVkX199VvAnkLDYkNkLbOknNRUGwOdNOvaqcf8=",
            "cpf": "U2FsdGVkX1+uEBJsjDGVWqh9I9WpBklfNhXZYR7y7YU="
          }, {
            "num_cand": "U2FsdGVkX18rKpxuStKkzrCrc3hSrRoLHRF0f4P5ymE=",
            "cpf": "U2FsdGVkX1/p9LlyL0UWv84aMfxPotQQlBii/Tnbcfs="
          }, {
            "num_cand": "U2FsdGVkX1+2rwoz63B68VVF8cFhCz/sb4gsHeTB+Eg=",
            "cpf": "U2FsdGVkX1/dnDFXZDSf7fF5BOr8cT7Vup1SUV/f1So="
          }, {
            "num_cand": "U2FsdGVkX18XaxvXpD4LYxlpuq7xyl6vge5BYOXBkOE=",
            "cpf": "U2FsdGVkX1/a1NtBeo0c8bvYn8LXLLGtnpQPX8We7FY="
          }, {
            "num_cand": "U2FsdGVkX18wZZ3YC2vVMs6+sp1reyzjesKNNfSWnx0=",
            "cpf": "U2FsdGVkX1/xLwxr4fZUOGVx7yYEEjVki+SDwfLb/hA="
          }, {
            "num_cand": "U2FsdGVkX1+gpXUpAwgtJN5dnDuBTcvHyKQKQZIbIl0=",
            "cpf": "U2FsdGVkX1/6UnMjE/V/QsAtYpJqQSDGY3eNAlqrJko="
          }, {
            "num_cand": "U2FsdGVkX1+L5JNJRXdyZGEowRktJhiq/BIPjlsBMlg=",
            "cpf": "U2FsdGVkX19mFI8VvMzs7Yyoqj5LQPeGHCR+FAP6dLQ="
          }, {
            "num_cand": "U2FsdGVkX19i5ifR9HUu2pwTMVjviJvl4a9FZbzpGt4=",
            "cpf": "U2FsdGVkX19MzgldflX0TSf3lMyxbMvIN1IZbPoVVk4="
          }, {
            "num_cand": "U2FsdGVkX1/FO1mfCNQma9FkQJh8i4cQj9+lq/5tXxw=",
            "cpf": "U2FsdGVkX19CFOQ4NRGA5YUN00qASAlcxqWSbgPA638="
          }, {
            "num_cand": "U2FsdGVkX1/8RCS2HEfCrd/jiHOuJbUgjMMYOVpM8xk=",
            "cpf": "U2FsdGVkX18H4XvoKfbdl6pQng+KAkgyVQ1+WAcTNwE="
          }, {
            "num_cand": "U2FsdGVkX18yfSxAMDvbQnDPasRioF0kJOM+zK4O9bg=",
            "cpf": "U2FsdGVkX1+2uEAyW6K4MRTugzTnT3maTN6Q62Rv1BQ="
          }, {
            "num_cand": "U2FsdGVkX199IGDcVg0h3saKaJGsLQUYZHQTQSHgANs=",
            "cpf": "U2FsdGVkX1+CphVWVPt1NLN4v8yLm8JGwWcU6GPDatc="
          }, {
            "num_cand": "U2FsdGVkX1+TDNx2RAZAJaA0tqqe+MXguvY8jpPwctI=",
            "cpf": "U2FsdGVkX1/NFYMF4KKZOgijpOSXXnd10AhJ7Miy9Gc="
          }, {
            "num_cand": "U2FsdGVkX18N4PDICr222AjTrF7NKWCQV3CzANFPHE4=",
            "cpf": "U2FsdGVkX19o0Obm3VbCiNc5zraApA+XKdsY5TA1Se4="
          }, {
            "num_cand": "U2FsdGVkX19T1xVAxcQDdpqgpTVyhUrmn7y9mfEJTyQ=",
            "cpf": "U2FsdGVkX18+DxQg66AheEQ9uNjX6YsfoDHQrJMbOy0="
          }, {
            "num_cand": "U2FsdGVkX18T76SJSvQkK56hqtETAhTaNcPGOnpU9Tg=",
            "cpf": "U2FsdGVkX1/A4J4y/eehXoq9AW3kss5nVtPwN/dGp2c="
          }, {
            "num_cand": "U2FsdGVkX1/EgUz0oct2KOXRFcZRMYcMG+IQNNQrdGw=",
            "cpf": "U2FsdGVkX1+0juH5FSXvuKsALVmhRHDTzLYXOUWT8Y8="
          }, {
            "num_cand": "U2FsdGVkX1/NRbGsl22lO6198YhPFSmNexUyLpcGOPk=",
            "cpf": "U2FsdGVkX19D/SQv09V9LE8fffeUc29rsSlmxSlMdIs="
          }, {
            "num_cand": "U2FsdGVkX1+psc6/bc3cCtl6ZM6p810PJGvuX9igBmI=",
            "cpf": "U2FsdGVkX1+mgVOr4Lx6zTUzTi/QqN/er+ufd9AILoQ="
          }, {
            "num_cand": "U2FsdGVkX1+daQaOEiX2W8oJ4dpfEj/TXgUUKEZvQMU=",
            "cpf": "U2FsdGVkX18p2ScHeb4XCJE28wZMENXNXTqWGTF9V/E="
          }, {
            "num_cand": "U2FsdGVkX19/dee2o5V7TFsHJfE7XhX2X4VtAAbkBmE=",
            "cpf": "U2FsdGVkX19DYkDP5fGHXPYbBTnoOXcgRHI3Yj/eT9A="
          }, {
            "num_cand": "U2FsdGVkX18T2R2hWY/RnnpPM4byOGEZRMJOkkXB/Xs=",
            "cpf": "U2FsdGVkX18up5yaObqPMvrLMO4UDx+La23n5mnEOeM="
          }, {
            "num_cand": "U2FsdGVkX19zq53sq97NcuYyEcvRaY2Y1wC6hcXuZeM=",
            "cpf": "U2FsdGVkX1/kNg0seIMMSyQOubzIY9FHnL3JrbOG6w8="
          }, {
            "num_cand": "U2FsdGVkX1/MvIYjwd68YQpHGd4tmaqYy4HHTYNKSZ0=",
            "cpf": "U2FsdGVkX19uB89AmSeIyEsb/HKHyUkBBk2f6OneQls="
          }, {
            "num_cand": "U2FsdGVkX19OhkianYZuA8SgnFWAwkVWHzVVjij67cA=",
            "cpf": "U2FsdGVkX1/nuAGAU0ybVqus4qYC66wxwutE/JJVLDg="
          }, {
            "num_cand": "U2FsdGVkX1/FkJMvJqomleveNbyFyUyieIQOghGXEcw=",
            "cpf": "U2FsdGVkX1+eFXut8Yb2qlNS0EBFeON4VsjfI1wvYDs="
          }, {
            "num_cand": "U2FsdGVkX18a+JHmm8wrENu4SdhqS408WWrvgAk1Qyw=",
            "cpf": "U2FsdGVkX187KuhFLkN+wj7zo5tuKHLPcM+vd0hUoR0="
          }, {
            "num_cand": "U2FsdGVkX18kLhQSpsswATclwij0Ty9ZKBv7KVr+k50=",
            "cpf": "U2FsdGVkX18cdgrc+oe9/Af6rXTggk0p3DRNL8yHa7Y="
          }, {
            "num_cand": "U2FsdGVkX1/PBmk8ONF0D7FpcPTtG7DOMY3bStWXYOs=",
            "cpf": "U2FsdGVkX1/s1Mjl1XeH6IzVCRVfwso9Pf1r0UMk7S4="
          }, {
            "num_cand": "U2FsdGVkX18LH/TlP97QeJrhWdYEky92Wkf9MQs5bnA=",
            "cpf": "U2FsdGVkX1/bf8w3f6V4RNeZZczHrOQHN9Sw3K9R8YU="
          }, {
            "num_cand": "U2FsdGVkX19TnNVkxm6vhE2BE20inYX2SE/0CQH7Hac=",
            "cpf": "U2FsdGVkX18KeDvWQ4IrOqY6BKxijQp4KnWU7JCsPJc="
          }, {
            "num_cand": "U2FsdGVkX18IGPbrx0BOWE0+kIQvewDIxBkFzBnoWm8=",
            "cpf": "U2FsdGVkX181D1VwcKED2sYwWHyhPaNgq/6zkyM4T4U="
          }, {
            "num_cand": "U2FsdGVkX19F1abs0oiMaNAqBkqj4Rgy5HVHoWKolvg=",
            "cpf": "U2FsdGVkX1/DW40YPaCExz2OP20TsoDBNkjeFK7Y9b8="
          }, {
            "num_cand": "U2FsdGVkX18YbiOFEIEB/0ighQ76mDRMhm2UEIX8lPQ=",
            "cpf": "U2FsdGVkX1+j6O1zfyRbjyidPdty08fh0eHxnENK4ps="
          }, {
            "num_cand": "U2FsdGVkX1/7cYAbO6GIG4ueayjlrIfuiVU5/BnqEKY=",
            "cpf": "U2FsdGVkX19suzr2fnZ7yrT8CFviVmSQ7ZqX1n9Rqds="
          }, {
            "num_cand": "U2FsdGVkX1+RSOSJXYko56rjX3rRdChy+J9Dg9N9chI=",
            "cpf": "U2FsdGVkX19BxwTs+nWHPB3BN/2jZR2vtbVKk3NSwr8="
          }, {
            "num_cand": "U2FsdGVkX1+QBPHn43MyiMpsEsB5BYX879lfRhYo9uI=",
            "cpf": "U2FsdGVkX19iUQ75vMZH6Li5gdtngO28jV1U5yvjBl0="
          }, {
            "num_cand": "U2FsdGVkX18lCwurI2jNdbjTpTFErRTXUgvokmCHXq0=",
            "cpf": "U2FsdGVkX1/Ye4ydPkYJU+Eyp/b2ZBR2cw968LTQEuA="
          }, {
            "num_cand": "U2FsdGVkX1/+rJAi9oNQytOcQ7Y9fKM6cSdznqyuLsM=",
            "cpf": "U2FsdGVkX1/a+Y3Vy7Gkj60N1OX5WjnKjAizG6YUTbw="
          }, {
            "num_cand": "U2FsdGVkX19noup3Lm/BtQDZC5iOWnUpvvXXxBf7CQc=",
            "cpf": "U2FsdGVkX19NDh6TxxOQxEMfVCOW7nIoK+HKa2WC+Eo="
          }, {
            "num_cand": "U2FsdGVkX1+raN8vsQkNKB0/F2wd1tNnQeFxIps2SYI=",
            "cpf": "U2FsdGVkX1+y4efZDBmVEWFMyghYVuxnkoS/5gSFww8="
          }, {
            "num_cand": "U2FsdGVkX19Az7RMjrQV3noszmj1/91KpyX2WsUYUZA=",
            "cpf": "U2FsdGVkX1/7tRyuOd+yGZFxj15OgnvFmtG/cmTdrZo="
          }, {
            "num_cand": "U2FsdGVkX1+c11WJ7riNCok81+kefiQ+iicve3pwTgU=",
            "cpf": "U2FsdGVkX1/KNAaLsa1vsm4nJE85xXXWh5Yc2Qgty6A="
          }, {
            "num_cand": "U2FsdGVkX1/Dq9T8is2/bkhdoYyK3+FiT/ZUB/YM6V8=",
            "cpf": "U2FsdGVkX1+zKei+DbBI9//4fmqX4B7NEz7vztPxEUk="
          }, {
            "num_cand": "U2FsdGVkX19NmpfMndfZZVq0L3LsbSQSlvmwarV1cMI=",
            "cpf": "U2FsdGVkX1/CX9H/Q2CkIuWAGeJB+yp2beCQE4a/PM0="
          }, {
            "num_cand": "U2FsdGVkX18WWpA3MdnrMTKQvRwPxQE01EkdGsAyGq4=",
            "cpf": "U2FsdGVkX19rXwYyr2B5wbN/lfzop5ZOXkMcUazKbTQ="
          }, {
            "num_cand": "U2FsdGVkX19bGCm/D2B/9AFn1E1tMcYy7wRHp3V9YR4=",
            "cpf": "U2FsdGVkX1+AD5i9i1dFD8fxvaVze1oPrs8wBACUv9k="
          }, {
            "num_cand": "U2FsdGVkX19NB/V99lfvYojHFjH/VqHOCLJjUWDBYm8=",
            "cpf": "U2FsdGVkX18L2RGL2WVuNrcffWD90jV3zkdgR1Bde38="
          }, {
            "num_cand": "U2FsdGVkX19cAvj8L6gVIgD9o+d4P4zIDa0nDw9ovnE=",
            "cpf": "U2FsdGVkX1/fwPAjOAn3eGE1fZLrF1KJ8BnSAarxOrc="
          }, {
            "num_cand": "U2FsdGVkX19V7CB2gte8vSXP5aj6rsMxmS5xC4Lka60=",
            "cpf": "U2FsdGVkX18mJzlT8MntvNhDKGXUOffntFAUPq744f4="
          }, {
            "num_cand": "U2FsdGVkX188lxUyV3MaW+JpzGgT1hBcu8h2dfmD4s4=",
            "cpf": "U2FsdGVkX1/1uWt5WbsQC/5YJrmtWvDRj27PXVlXxLc="
          }, {
            "num_cand": "U2FsdGVkX1+G5Tvu+1gBs3isX1/1QT8MPw7ZcfelZuk=",
            "cpf": "U2FsdGVkX18ET+sC3pRw/pZiKyZzVquCY88YDbcsOsI="
          }, {
            "num_cand": "U2FsdGVkX1/aaG/yKNVuYvc8HJpzyaLU8YoGIjxr//A=",
            "cpf": "U2FsdGVkX18u2dXBc7rvMWv+s5wpisfQ0SkZHCsgKnQ="
          }, {
            "num_cand": "U2FsdGVkX18rEj5lDfb5PyWHWoGwWoCwe+bgFpiytbA=",
            "cpf": "U2FsdGVkX1/zAJbr2XP/Jn3W2TsA3QbS8ms0fm7blXc="
          }, {
            "num_cand": "U2FsdGVkX1+gCtDowUzFn8Gq7WebUTOv/YjGVgdSJ3k=",
            "cpf": "U2FsdGVkX1/yaAg1gjhh0XIgx9s+HNvjnFIX/EUE58I="
          }, {
            "num_cand": "U2FsdGVkX1+Oc9D+zfFB1p1Depv98jn5EyumAxAVsZU=",
            "cpf": "U2FsdGVkX18xxQI9SV4n2sE/rulu/w0JX4IUjJkLLW0="
          }, {
            "num_cand": "U2FsdGVkX19wdFFvykLYnYc4CuN1SST512XIjbVGmXM=",
            "cpf": "U2FsdGVkX19xkqxQti/ro8zKnE8sZSkljAKhGrsnFSs="
          }, {
            "num_cand": "U2FsdGVkX1/SRdNNNlu3eXHfjFQQ+6T8gwtr5kUZv20=",
            "cpf": "U2FsdGVkX1+m/sCk3UQtMXBjzXJs31n33+WG6y0sT2E="
          }, {
            "num_cand": "U2FsdGVkX19babZcplh49pku34TWLuVW3rYi87uJ3Vc=",
            "cpf": "U2FsdGVkX18pqsgP1UF64FOruMyiFSlqb/+Fetc03to="
          }, {
            "num_cand": "U2FsdGVkX1/2cP46gKot6Ubc2wDqNKe6X5bpzpmjWZM=",
            "cpf": "U2FsdGVkX1/pEgxdfMBUqPIO76dXvLKgWuOb8LBq6cI="
          }, {
            "num_cand": "U2FsdGVkX18sywoel6jhLvkWgTeT4jqAlhEfl/VaPDs=",
            "cpf": "U2FsdGVkX19pRpHxlHn95kHsdLL8zPe1LGgijYTcwUU="
          }, {
            "num_cand": "U2FsdGVkX1/hhrjCeMCs1J3PfZAh3DOhIpOGGbZU7hw=",
            "cpf": "U2FsdGVkX1/z0Nn2TMDsO2UZrz0sqt4yBfQmnb2ky0s="
          }, {
            "num_cand": "U2FsdGVkX1+l5RaIKY7VWbRfFP9+HAAJdqsGtGYaTkI=",
            "cpf": "U2FsdGVkX18n2JxL4sEmojA+gxzVoN4A4aHVcfAegTo="
          }, {
            "num_cand": "U2FsdGVkX18LOFd28DBjV5gLqvDAPd8buUECX1bARkM=",
            "cpf": "U2FsdGVkX19OPlnpxuoIQPVnzBlg3V6oxOEwJoBNVIY="
          }, {
            "num_cand": "U2FsdGVkX1/h+7yTPdEE3lVwrk0pRWbgXxlVqSl95hw=",
            "cpf": "U2FsdGVkX18e05j26nM/4dl5c8e3HnnhRAzJFgQUahA="
          }, {
            "num_cand": "U2FsdGVkX1+G3QuSaNCpa7r5FTUHMspNXeYUGef+Zng=",
            "cpf": "U2FsdGVkX1+RKCAuNTiI2vkzRcjdqPGbaM90clKc2Qo="
          }, {
            "num_cand": "U2FsdGVkX1+XHAO5+xB2v9uZj6h0PHWhIILoes9KgWc=",
            "cpf": "U2FsdGVkX18GKdtoi8pUFy4RZXcGdf2KkQ3EYLysmaA="
          }, {
            "num_cand": "U2FsdGVkX19cpoNZHZnwfRCLIgOzyi6keJB5tJhG7WM=",
            "cpf": "U2FsdGVkX1/AgMlacHrIQyOWc7u8R9XZQZKVO83lD1E="
          }, {
            "num_cand": "U2FsdGVkX18ikFgai2PLeCKGWs3KN7h00Bd/OgfehpA=",
            "cpf": "U2FsdGVkX1+OjXQmil4PVwSsasyQwVKphaVDDWbDQK4="
          }, {
            "num_cand": "U2FsdGVkX18imcDVdBaK33jvsPpRbrxA1hg511PY9YA=",
            "cpf": "U2FsdGVkX1+cvBXe5jUlpZTOjOvl84DxRDDjfskupno="
          }, {
            "num_cand": "U2FsdGVkX1/ryFYeInVxqUfGXSULNDXWuC96pMZcHMs=",
            "cpf": "U2FsdGVkX18J1sQzvfwtteGsqeLd3KZshVNWyr1hz1w="
          }, {
            "num_cand": "U2FsdGVkX18h/pKhTf4z9t2oKCcj7BU2nWr8kvPtFak=",
            "cpf": "U2FsdGVkX199U/LY+ZDHqWFZh5QL+L6ZqXna70VaYv0="
          }, {
            "num_cand": "U2FsdGVkX1+zndCBFh1d9+gXSS04dKMH99n/b87ZGBA=",
            "cpf": "U2FsdGVkX18gSpHgQYa6wluSIAxLLCWIJKzPcygRZ7E="
          }, {
            "num_cand": "U2FsdGVkX1+e4sdEktpw0zO98H0vXJMNrTiHCkA0/oc=",
            "cpf": "U2FsdGVkX18wlaAs0/nAfIV5IS+MmzfPGoKC8wC3rJc="
          }, {
            "num_cand": "U2FsdGVkX1+NLbQXCOWlVyK8h29rJKs7Qb35FXKagbU=",
            "cpf": "U2FsdGVkX18plNxLH0eKdY9oPFI/2xQ7X1YH5wUyQg4="
          }, {
            "num_cand": "U2FsdGVkX18iQPe8SUtp23aUfvP9VDhaIZ/99mkce28=",
            "cpf": "U2FsdGVkX1+CX2venz/DrQj31XllnB3k1n7wRKQTWQc="
          }, {
            "num_cand": "U2FsdGVkX197N8qf0M0/EJacp9t+GsK3lvBuvxRU588=",
            "cpf": "U2FsdGVkX1/AlRxvsLsbFlOAb8k4KkrmN24/GvJBpLw="
          }, {
            "num_cand": "U2FsdGVkX19UK95sD2qqUVlzgcFTm1mbFjBvuLzx9wU=",
            "cpf": "U2FsdGVkX1/pIpP0Df9THeijiTGolEh+fLoaFgrFWuQ="
          }, {
            "num_cand": "U2FsdGVkX19n/o1WwcvMO7eHT/dE54ysSAGqcHYpMXI=",
            "cpf": "U2FsdGVkX19GSZ2Pv2L2Hy4AcFLQhUP1ZLFvMZ++e7U="
          }, {
            "num_cand": "U2FsdGVkX1/5+ivJjD1W4mgmZA/dbqLvnkWV0mE2j8Q=",
            "cpf": "U2FsdGVkX1953PvtjZbsMGEwAPXibqUI/GkEZQKxVew="
          }, {
            "num_cand": "U2FsdGVkX19iRFgrMeIkzZxo3QLYLQ7eyGrrZNrlAE8=",
            "cpf": "U2FsdGVkX1/vR/31eHtSK0/UoJ4LkFad0smFKCpF7+g="
          }, {
            "num_cand": "U2FsdGVkX1+c+slGcHnKsy/ux/qnMc2HnJZjrxlD3gM=",
            "cpf": "U2FsdGVkX1/P7JxG5/20LLZ+qomZtJCZkQgfO55Fiig="
          }, {
            "num_cand": "U2FsdGVkX18K64N1xAAjPwy/8zVSA1apZcbn1X2NZuw=",
            "cpf": "U2FsdGVkX1/i7r+T+R3m/5QlUWvP+Y1DSJXkT3uytDA="
          }, {
            "num_cand": "U2FsdGVkX1+ArDYRDyIVTChoykgb3xCZV+wn9tyd8XM=",
            "cpf": "U2FsdGVkX19mmWuY3Dl10WgDghg4/97/VAiN7MJW1bs="
          }, {
            "num_cand": "U2FsdGVkX1+0pzFfLDgj7lQ3a5YWB6/O6QW/3ivhgnw=",
            "cpf": "U2FsdGVkX1/rjdPjhgHhhZX86qZoxTXmvDVhyxudkwg="
          }, {
            "num_cand": "U2FsdGVkX19IFsngBI126LTFhq71thdly7Q/DSfDtuw=",
            "cpf": "U2FsdGVkX1/JceqggtNQU/aJ+BiMHgDrcZ5pcMVAer0="
          }, {
            "num_cand": "U2FsdGVkX18XQu07o8MB8czMZ7PeyMUDrGGSs+geyfA=",
            "cpf": "U2FsdGVkX1/FRUq2ludr69/xsTqHf2412ZhCUaTZL6U="
          }, {
            "num_cand": "U2FsdGVkX18XtgIEnjwAmmOBmgtJoDHfYUy4Gf+y5lM=",
            "cpf": "U2FsdGVkX19PQrbtR+2oCS+qYBiWvTVQzN9i+Iw3YJw="
          }, {
            "num_cand": "U2FsdGVkX1/L9XEOwLHj1CiY8nzOCoKVk5Orx+4EhqE=",
            "cpf": "U2FsdGVkX1+YnVzFpLJyLAqjRcjPcsgp7TtXnG82Obs="
          }, {
            "num_cand": "U2FsdGVkX18jSg5cvvdauKVcFYL1iYwXop6fEXuo7x0=",
            "cpf": "U2FsdGVkX1/kq/EWKsQwmHOnVMFR6IwuAx90D4/XUQ0="
          }, {
            "num_cand": "U2FsdGVkX1/+dZbaVVhGJaEZrH3ZGX/WEuou5/3/k/I=",
            "cpf": "U2FsdGVkX1/6nESCHblRViafGTP6jZoIyjOKbkIWIoA="
          }, {
            "num_cand": "U2FsdGVkX18nieWN8sCN5BM00qXvzqqLHoKO4ANl9+o=",
            "cpf": "U2FsdGVkX19PLeXsW0SO0NW80wYm/b84WRQ6wYU6IHs="
          }, {
            "num_cand": "U2FsdGVkX1/KGf9jyJ4YZqOhAKvaOZYsGGEpj3pDe7M=",
            "cpf": "U2FsdGVkX18ZWZ4azv3Hrybfym37zXpL0lOPwrERzuE="
          }, {
            "num_cand": "U2FsdGVkX1+F+sLtIkefKbn2LZa56FtYxAtPOxX/97s=",
            "cpf": "U2FsdGVkX18hztT7zmt7+n4QB2v3jeRzeYQumG25suc="
          }, {
            "num_cand": "U2FsdGVkX1/PdfDtPEeOwpZqe7P2hi2kZc1YqXBk9gQ=",
            "cpf": "U2FsdGVkX18SBL6fiEVmUiKp/QcntIRGc27lZxZonfU="
          }, {
            "num_cand": "U2FsdGVkX19Uxi/TyDhOFOSs35AH4rk3zsZiyboUvck=",
            "cpf": "U2FsdGVkX19rfcsExoC1dljF63BaxxEGvPWVRO2J7dI="
          }, {
            "num_cand": "U2FsdGVkX19ZxdaAuuyVJxwzuaHx9XBJ/4cH9ksN4bo=",
            "cpf": "U2FsdGVkX18fT4Ra9FHSQ/3qbxGyZYXR0uBeX4Qwljw="
          }, {
            "num_cand": "U2FsdGVkX1+aVUlAeIl7W2cCoGpErylI/7SHbZOcZ98=",
            "cpf": "U2FsdGVkX19hvms/6BTnSFaEjhNdm/F7NNEu8NsuNUU="
          }, {
            "num_cand": "U2FsdGVkX1/PhTiU2jT0sI3abMxqFcEhziI1sl9CokY=",
            "cpf": "U2FsdGVkX187KN2pOD39esrH+0xFgPCk7kT1yA72rpo="
          }, {
            "num_cand": "U2FsdGVkX18ohuYbCgRJS/E9rX+vCP9AbjnnfvGVdWw=",
            "cpf": "U2FsdGVkX18j+8MY4MY3+L6HOY3ildHtc5gZyNyQLlU="
          }, {
            "num_cand": "U2FsdGVkX1/K4Q65fsmGzT8xFE/vkvFxYvJy1iVWlaY=",
            "cpf": "U2FsdGVkX19xCNMlWXcVJW7CioZ0vB9GjNQEXLCtPyo="
          }, {
            "num_cand": "U2FsdGVkX1/jezeoWlgcZO1c8Ayalw1a+H3YeIMk6zE=",
            "cpf": "U2FsdGVkX188QJZCCWcRIeCr1Smo7Pw2UkCIFsrJcA8="
          }, {
            "num_cand": "U2FsdGVkX1+KtSFLOeQE8j5vnGlYy1upamLabW1mjqo=",
            "cpf": "U2FsdGVkX1/g5b1yqap1HY0LebBxkM7BuQmFUpCQhlY="
          }, {
            "num_cand": "U2FsdGVkX191Ni2fkyGhuaZtSH0bA4a2mbiwBxmyxR4=",
            "cpf": "U2FsdGVkX185JfSV464NjeGlguycm3Z/lHaS898Qw2A="
          }, {
            "num_cand": "U2FsdGVkX19Cy6cf9KUoUNgiXof0DVNo1Zpot/fWASY=",
            "cpf": "U2FsdGVkX19a5s8KeafTJbV1pndck312lJtZMnMDyQQ="
          }, {
            "num_cand": "U2FsdGVkX1/R33pgyTCgYeKswf/FuJYrcrEm5b0zNvw=",
            "cpf": "U2FsdGVkX1/ZDwFemsA+3+mUTKmX9NDRbp7mfPB5yFk="
          }, {
            "num_cand": "U2FsdGVkX1/nDT7lqxGZb0vXI+PR5KQBkwQP7KnzlSk=",
            "cpf": "U2FsdGVkX1983I/aaLWuTmz4lzOYZHR4TbQ50RsUSLg="
          }, {
            "num_cand": "U2FsdGVkX18vbPurjeN+sALpVi9JzROQ0C2Pl+lqjg8=",
            "cpf": "U2FsdGVkX1+TDyOGSqp5NOKiRQfV7DWTpGKyrWlpopE="
          }, {
            "num_cand": "U2FsdGVkX1/V4Z9EqWLs5N5lGVeKE8QSMqus5yW6JGs=",
            "cpf": "U2FsdGVkX19rknNpRRGBqpFjQSvJPY1lLilUc225gAk="
          }, {
            "num_cand": "U2FsdGVkX18rGlFBhSTmLP9H3GiFmwgqqGCcbhOjBN8=",
            "cpf": "U2FsdGVkX1+xV+Ca9PJn8C8XgyhnIPDMfsu4WzEDrTc="
          }, {
            "num_cand": "U2FsdGVkX18KfJNF24CjMbR059yO4MYQRuA3dtJLWlM=",
            "cpf": "U2FsdGVkX1+dfK7PTTyRcMCV3uN8YuJkIV6cJl+O558="
          }, {
            "num_cand": "U2FsdGVkX1/5uYesx/Nmbq7R+N9jHw0jr6G+BKSK2+M=",
            "cpf": "U2FsdGVkX1/zs6ywepMJZnK/s6Ho53z5dqk/Zl3h6do="
          }, {
            "num_cand": "U2FsdGVkX1+3d9MKUdp6EHDnoKZXBcSgj8uKClXJIzM=",
            "cpf": "U2FsdGVkX18SXoRPwHYOTgiFewDrWXNS1L/9erLpLdo="
          }, {
            "num_cand": "U2FsdGVkX18M+qvlHlQ/N0csCzLuyJ4ZY7RJnEGBIQ4=",
            "cpf": "U2FsdGVkX18ceY2EknWJIL8/rj+M3BuLxz5NtK2uL2I="
          }, {
            "num_cand": "U2FsdGVkX1/U5eV8+d+wb50z23kOK5AVgr0e+BbQ4i0=",
            "cpf": "U2FsdGVkX1+4UAyyojFNj814Q9N7+GpA5Fp2fNSucTU="
          }, {
            "num_cand": "U2FsdGVkX1+yXkc5fuYb7nQ9yQ2CRmPTdJryYtkqezU=",
            "cpf": "U2FsdGVkX1/J8EWqACFIebLIkz+iYWaedqJn5EhGGxw="
          }, {
            "num_cand": "U2FsdGVkX19XGj0qbJ9Q3uRTCMQP2tBikTG7hfJE/nU=",
            "cpf": "U2FsdGVkX1/EwUDkkEZDlw+ToLEPh5CD1OosfeigNpI="
          }, {
            "num_cand": "U2FsdGVkX18T58mjgrV+5Ye7X7jz+LXQ62OZEQtJDsY=",
            "cpf": "U2FsdGVkX18+/LC0Mh4nYWXNQjXDvQ0016dAi0EzPG0="
          }, {
            "num_cand": "U2FsdGVkX1+fAwkDlofKLKWrS8bLphqjHJH+JkRtzRk=",
            "cpf": "U2FsdGVkX183F3FsCzWn/NTIbIvLLw99zAgRSwOtTWM="
          }, {
            "num_cand": "U2FsdGVkX1+89WDH+ItYug9JtDK79zlctVLFHmX7yA0=",
            "cpf": "U2FsdGVkX18tBFlT7Q4+1OwFDySsEkSXbQNC0Zk8qZk="
          }, {
            "num_cand": "U2FsdGVkX1+kQgw2BgXAGvz+XffsQ8psIRyJlM7BSM4=",
            "cpf": "U2FsdGVkX1/0CNz9k5+oFlkQ1GiI3/lg/7mJbJUlm/Q="
          }, {
            "num_cand": "U2FsdGVkX199qOuM/+gMTZ6NZQS1B4c2i6jT4UwgJq4=",
            "cpf": "U2FsdGVkX1+c0afWWs7d2lV/cVcGsjZo9QGPQGN18R8="
          }, {
            "num_cand": "U2FsdGVkX1+Qv+jRUwzJ2R/f+tZ1rv1Pzk9BBSmrfI8=",
            "cpf": "U2FsdGVkX192oVq95bIXQwxg9mQHP7IT/CQnVGdM4rw="
          }, {
            "num_cand": "U2FsdGVkX1/d0hbCIlbpyHZB9MX/LeJqQkkn9SQZ5AU=",
            "cpf": "U2FsdGVkX19XJgF1Puk1l6iwWvGTgQhFvxF0HJGX1oo="
          }, {
            "num_cand": "U2FsdGVkX194oDxP9pnJXfsb31YWTiFh1d9XFFE5e+Y=",
            "cpf": "U2FsdGVkX1+6Qk0e1QQ6ncM7L0OFy9cOBzO2CGIJujQ="
          }, {
            "num_cand": "U2FsdGVkX18oZrUxJTsIbUdMi4o0HfE4Tz6X/KvzW4o=",
            "cpf": "U2FsdGVkX1/dLoctY+bngUkFDamrLzTCAJykZuM8XZQ="
          }, {
            "num_cand": "U2FsdGVkX19j+STavzRH3ngMbOZKOYGi+H5it2yZbxs=",
            "cpf": "U2FsdGVkX1+a1FZeiCnnyG5KIUOIef0ONus4+Ek7QQ4="
          }, {
            "num_cand": "U2FsdGVkX19lx1N8wHTJujsENNb5d584+ZzIDQ82GMU=",
            "cpf": "U2FsdGVkX1+1IFs9/N/rTwO3i67ZAHTuMdwTXdm2OEk="
          }, {
            "num_cand": "U2FsdGVkX1/dR7W8ptgrIgZipi/m85BWd5HPKYXMtKo=",
            "cpf": "U2FsdGVkX1979MqnKqiKZq9V7uypqizMmBQZl846jRk="
          }, {
            "num_cand": "U2FsdGVkX19Y3MlsgaIOevfsVG0rxYScZBposa3rcek=",
            "cpf": "U2FsdGVkX19u1LSGyQjqxPoObFUuB4Gu2tkqxmSwZY4="
          }, {
            "num_cand": "U2FsdGVkX1+qG6MKFOQnZ/Ue/07P/MMyuGGDhuch2s0=",
            "cpf": "U2FsdGVkX1+Runmj6M/IymYfy+nGabxoIu080YPobHc="
          }, {
            "num_cand": "U2FsdGVkX19+BL4Et/QFiqaBXISgxh3zVWNDKCNphps=",
            "cpf": "U2FsdGVkX19gvgZLPrfP6KDq1ZJ66un22lPMPs3Ndqg="
          }, {
            "num_cand": "U2FsdGVkX1/sCqsJ+iiuETB6uZA4m74+kb6Y4tyiv8Q=",
            "cpf": "U2FsdGVkX19KJvDsogFDIq1shEXdUg0Pb1DGJmycMMs="
          }, {
            "num_cand": "U2FsdGVkX1+WGNwjc599nnWglCi5qAlEyGjKFgPa/VA=",
            "cpf": "U2FsdGVkX18Wvhz0dPHH/2ZtnqSV7Uj8x5Fxu50rGOs="
          }, {
            "num_cand": "U2FsdGVkX1+J8ge9HRabZL9Q0oU2HTBj68QEl5HCQt0=",
            "cpf": "U2FsdGVkX1/zZxHYR8rJwLx0neOC0GUYBwralgH9YGU="
          }, {
            "num_cand": "U2FsdGVkX19Nn9Du79jEY8PDY74/qC65OiT5sWVqSWI=",
            "cpf": "U2FsdGVkX1+MXgo9cbg7SEPfU+W6z92r8HYjvUOrxOg="
          }, {
            "num_cand": "U2FsdGVkX18cVPvYnfdXoK7crWrcCKFHI3uEVn4WHDA=",
            "cpf": "U2FsdGVkX19qY11tlTGHvuQ8dHjxhE9CFWyhzmIEGx8="
          }, {
            "num_cand": "U2FsdGVkX18kyaeFziCCGe6ZnuVARmqtNYeu9uTgDgM=",
            "cpf": "U2FsdGVkX1+BaEzlLqraZ6G7kiRHjt/SWsus/aVyPtw="
          }, {
            "num_cand": "U2FsdGVkX18kwUUjo205IT4QQw+DrGdAT05sLCfmxsc=",
            "cpf": "U2FsdGVkX19ErWo+IZa9OjmXHZH0p/8UAwl8uMGt4MY="
          }, {
            "num_cand": "U2FsdGVkX1/c4IFx9vdowyOjmVrmz4fUXxo7DSf2ddI=",
            "cpf": "U2FsdGVkX1+YJwwjCrkwl8ABHVkC+Topa573DTXMuLU="
          }, {
            "num_cand": "U2FsdGVkX1/QbbGtFropSGsxznnCjIZQGeqZGOguye4=",
            "cpf": "U2FsdGVkX19Visbow2lIdzMmo1pCCsmELon0IUlMeJg="
          }, {
            "num_cand": "U2FsdGVkX1+3HwI6u4FCN7m9WtlwIJ5nqDUWQkc7Skk=",
            "cpf": "U2FsdGVkX18Fh7jOi2aXEgqnmwShtSvf7iYrMdo1Nj4="
          }, {
            "num_cand": "U2FsdGVkX199hf8E5bMW9Sg4J2AD+wD/y/V5j1OpYUo=",
            "cpf": "U2FsdGVkX1/rO2pN4w6kUq4IJLJBlyFfITUcWVBaBEs="
          }, {
            "num_cand": "U2FsdGVkX1+4Okod8VixTksVOm3VHBX2rjFdz0xLY9M=",
            "cpf": "U2FsdGVkX18wMgmc96Bto/UVBNG9yr940AxyWbwjGSE="
          }, {
            "num_cand": "U2FsdGVkX18FRRngEE8qe0/K8DwfPTpWCyc6MfVvcKM=",
            "cpf": "U2FsdGVkX19zOrgrqcQbTFFdLP+BD0tGFC+O9aG7AjM="
          }, {
            "num_cand": "U2FsdGVkX1/hVV/vJIE/GaMK3fMU2fU9bnFvLUCkFXk=",
            "cpf": "U2FsdGVkX1+IMjP1L0WusnUn1URLVSb/4UNZmjRNiyA="
          }, {
            "num_cand": "U2FsdGVkX1/vWLZMyyYOQ5jijxDkAKbM5Q4QHJ6qfwE=",
            "cpf": "U2FsdGVkX19soa2yQyhXfpxBooVvL7di0fuMM1qdJXA="
          }, {
            "num_cand": "U2FsdGVkX19fuK9F0QPtTVbnN1vUgWLPVnmRFFOjkkk=",
            "cpf": "U2FsdGVkX1+8RrawnLsTW2ClrW+JyJv7QCQ2qZfL2W4="
          }, {
            "num_cand": "U2FsdGVkX18vr+bcZTq2ko6X9uxiOxFEr+s1pAxBUXI=",
            "cpf": "U2FsdGVkX1/KH1KYQEjspd0jUdRJ4aG0yvWtDCJa1W4="
          }, {
            "num_cand": "U2FsdGVkX19/05kMS1BSgTzTC5vmb7W7CAT+kRrez84=",
            "cpf": "U2FsdGVkX1/yXdHSjr+6K3zzjexuqqimN5QT262v+Gw="
          }, {
            "num_cand": "U2FsdGVkX19s7ViHiVW4AMTmXEFJKhTl4XuQGGfXj8w=",
            "cpf": "U2FsdGVkX1/mg1pCeNbvD09iweU4JJYXtfp8rBKZGN4="
          }, {
            "num_cand": "U2FsdGVkX182e5Ch76PZRNigVlwJfLPGyZiFQ4aSAuY=",
            "cpf": "U2FsdGVkX19PBKTPmnEcg0iwjd2Drw7N78NqlEWMPLA="
          }, {
            "num_cand": "U2FsdGVkX18Dpw53J5awz90fXmJ33EDGcgN7mVVpm/g=",
            "cpf": "U2FsdGVkX18b9suMPM3gFychnWo8Qu9ifv0auxVQjMY="
          }, {
            "num_cand": "U2FsdGVkX18eei9+1fUCK0LudL/RYsKCLn3AlaJ8DJU=",
            "cpf": "U2FsdGVkX19r3BedlnQm/kBEd59xtAomEEsIA77qvig="
          }, {
            "num_cand": "U2FsdGVkX19X7aFfVdoFTUUBNLRZl+v9UXHGdKJiQKA=",
            "cpf": "U2FsdGVkX18viXSBZ0Y0Y27YcTbBZJ+FFxdL+gHm6vc="
          }, {
            "num_cand": "U2FsdGVkX18G96bHE9lwkz3zz4dWvyatxksWg8qGfJw=",
            "cpf": "U2FsdGVkX1+7Xbg1+YAQTK2Uk+SeXGbBobn1Y+nf83M="
          }, {
            "num_cand": "U2FsdGVkX19La5CXjlQY959yjRdmf3Nx+TUy6V9u1ws=",
            "cpf": "U2FsdGVkX1+NHRxAK+S2PGLUzG+aOHVApwoZmaL1PSE="
          }, {
            "num_cand": "U2FsdGVkX1+adncCjjpTzWnb4mTUVN8qLVUu/bkr0mc=",
            "cpf": "U2FsdGVkX18IGV4gLNXiWQWP++tNhA+wul6u5YRquT4="
          }, {
            "num_cand": "U2FsdGVkX19Xgxi+w3S6bX8agMP3BY2uY6gGq62msyc=",
            "cpf": "U2FsdGVkX196qnU4tQRTY4ZvxRUWK72LpO7gmEAyATY="
          }, {
            "num_cand": "U2FsdGVkX1/zSmBOoPmsA4fHFvPAhfcQCWBN2oWqP4k=",
            "cpf": "U2FsdGVkX19anlFYbX0mn6dOtrCnXjRPrAxrmh2bTx0="
          }, {
            "num_cand": "U2FsdGVkX1/e3BUI9wrrRC5PGfiohGjawZBCqf8aJt0=",
            "cpf": "U2FsdGVkX1/wUsRttxTr82iERjEhp5d3LPN0MsVXpV8="
          }, {
            "num_cand": "U2FsdGVkX18PtNg6iuFyyFS1cAAlGzVpK/pgTirRai8=",
            "cpf": "U2FsdGVkX19gdP4XdYpYBAfpICJBTBk94buuHwi2oJU="
          }, {
            "num_cand": "U2FsdGVkX1/PTaMsPzv7Ul6BK0j/H2fIXf0SMW1gLO8=",
            "cpf": "U2FsdGVkX1/f20bCIsz6+3jwVDSd3yE+clR2qSWmhR4="
          }, {
            "num_cand": "U2FsdGVkX1/oPZJGfsNQa0GhNedoa6qJp9t2Ibvt3pI=",
            "cpf": "U2FsdGVkX18ADsm4qb1VzTKVDgdNFJ2pcqfYd67sVi0="
          }, {
            "num_cand": "U2FsdGVkX18NHcDXsSVNqI0fKjMuc8W2Lp4Q7FknfEk=",
            "cpf": "U2FsdGVkX1+7ppj7vzib83KChBqwUebThO7nC64IAN8="
          }, {
            "num_cand": "U2FsdGVkX18Xp0Z9eiu1tptbdLCuaptYEHTYmn28GTY=",
            "cpf": "U2FsdGVkX1/I0VnQXi1mYJodXtKsoYj8yQP6i4ef+Gs="
          }, {
            "num_cand": "U2FsdGVkX18sBcdXL4FCvXxdnn/7kJg5VUDWKSz97Rc=",
            "cpf": "U2FsdGVkX18de3WKXlNi4QAn7hXCWow+E12YEFNhjXs="
          }, {
            "num_cand": "U2FsdGVkX189ipIr7n6623/x6hQMQY3G2D+9VPJ7PxY=",
            "cpf": "U2FsdGVkX1+1bnHTKZuN13CvE6hurRxTQcDMEJ/OANc="
          }, {
            "num_cand": "U2FsdGVkX1/rn62o4By8bFaU45ZAiu3vCCIj8IPsV9k=",
            "cpf": "U2FsdGVkX18b9lUzMFOwapZCYT1wn7EzhvgP8/tiN0k="
          }, {
            "num_cand": "U2FsdGVkX1/sVBnhGAV9CCdc9RpK+//2DhCR7dpjk7c=",
            "cpf": "U2FsdGVkX1/LexLZJWU8Fb8F7OYJsCD7sXAyNSB9/4U="
          }, {
            "num_cand": "U2FsdGVkX19Mr70nj6WxNThY4NZfOfLfvuWaBNIB7Ns=",
            "cpf": "U2FsdGVkX1+kbt9QOJ1d5WsviA34HWwdG8kV59KwNQ4="
          }, {
            "num_cand": "U2FsdGVkX18o2KI39U92u4bhj4Fn6rWRf8S5EMxIhtw=",
            "cpf": "U2FsdGVkX1+JGK4vriwuCC3iRzfBGU8nKlOs3so+MT0="
          }, {
            "num_cand": "U2FsdGVkX1+OQNo+gBizOtPaKLhNXuKr5ufTTj3ZDtU=",
            "cpf": "U2FsdGVkX18SBzu+gbDKElfhy8/u9SR4GAi1o/XFHeA="
          }, {
            "num_cand": "U2FsdGVkX19eCPbyjECJGCAJdKa3rF83LB/uklJ+Yag=",
            "cpf": "U2FsdGVkX18JwZRM7nngZAGhjO6ez8CN/VolNfEXk/0="
          }, {
            "num_cand": "U2FsdGVkX182T+o6YztOxKR0gtuW09rsW7NQdas9oZA=",
            "cpf": "U2FsdGVkX1+hpLNCtYD8gd2FGQJnoHPY9azmXkyv3GA="
          }, {
            "num_cand": "U2FsdGVkX1/87X1CTOvGUlE4RbfKUwqTifIQ9n9RKww=",
            "cpf": "U2FsdGVkX18QjYgSSQjMPN+lJj6miPTm+eQpZ/4/7Eo="
          }, {
            "num_cand": "U2FsdGVkX19H51gJ0aKsPkAQiLVOKbpkEsq0omccxp8=",
            "cpf": "U2FsdGVkX19+rUx4AKxwGYrd3yMwe3PZLppGNNUcSb8="
          }, {
            "num_cand": "U2FsdGVkX1+je7VDFcAtaJI4vght6W3T9y4CpYnV3OU=",
            "cpf": "U2FsdGVkX19A5F2FQWllvd3BuG6+ixoKD/fM1hvBjXc="
          }, {
            "num_cand": "U2FsdGVkX18hi5/yVTxXXsv5arOHZFNBV55Gz+yLO1k=",
            "cpf": "U2FsdGVkX1/S2lSmPTAdDqE0cAm3fm4yp72raZIREJw="
          }, {
            "num_cand": "U2FsdGVkX18F72eIrOc2/qN0ocEXHVvkpKBR5Q6RCBc=",
            "cpf": "U2FsdGVkX18lyZMlY5E4d6emdJcXq5QULnzchjTSADQ="
          }, {
            "num_cand": "U2FsdGVkX18jw8n+YciEf3e1HChx+d9pJjuKmPKheX8=",
            "cpf": "U2FsdGVkX1+zT2vDqShy0taCLe/49hSJc8UVmajdtbI="
          }, {
            "num_cand": "U2FsdGVkX18T5juuazWLwaNtX/diOBHYfbWEjQaG0GY=",
            "cpf": "U2FsdGVkX19Q3MBmkHd5lagcINfp2xE2vZiE4r4xMZs="
          }, {
            "num_cand": "U2FsdGVkX1/CkORBtqrZh7DUDJRCf/JdVwdCBUvmkXA=",
            "cpf": "U2FsdGVkX19UZDNNKOsm985aBTc9t71ZCwhjyiMt80o="
          }, {
            "num_cand": "U2FsdGVkX18skat8bnaUCcDMcRLncw4ZH+4TwdVxIzY=",
            "cpf": "U2FsdGVkX18GVlJoLjPkWpKzVhDQy9uc3si1jUXPewA="
          }, {
            "num_cand": "U2FsdGVkX1+mca4P2rawB9rEHt4oUQU3ekhs8IUkHfs=",
            "cpf": "U2FsdGVkX1+jCBXhCU8XANhNBAqQcX2xYCT8gsAPK+8="
          }, {
            "num_cand": "U2FsdGVkX18mijh9w1VUMvOXV4lp4ZYBEL6bUCMgJuk=",
            "cpf": "U2FsdGVkX1+PloAmAojXk/OftpRC0fM4awJVDoQlzUY="
          }, {
            "num_cand": "U2FsdGVkX182LmudGKTfACocDpN5wbf0UVieh+1B4T8=",
            "cpf": "U2FsdGVkX18uIrafCdZd4hQa2EnxCEl2WDT7C7kVC+c="
          }, {
            "num_cand": "U2FsdGVkX1/ONF0NbghfWuVBA2R5Q4Lx75yBvvEKb4I=",
            "cpf": "U2FsdGVkX1+R2KIrdz/CIgmBwyMU8hrYG+UY48T/g4g="
          }, {
            "num_cand": "U2FsdGVkX1+PsoxDG+e9hkrKv6nVkGMlyQOxoKJxI3A=",
            "cpf": "U2FsdGVkX199ct51MnRgsdqUk/OBvIZrOtDGSkiWzUU="
          }, {
            "num_cand": "U2FsdGVkX19l+hYE1Wd6FkDWSSm0djYkaG8u8DLfW2A=",
            "cpf": "U2FsdGVkX18RF0WnRrCbWB+Fu5G0uQIfCTuTpbIWTuU="
          }, {
            "num_cand": "U2FsdGVkX18Dm1KOOtQyvEwnWede01SBDJ042CXLrq8=",
            "cpf": "U2FsdGVkX18HRAYXAWlLz20m/1SILZuOak01BfhKZ7I="
          }, {
            "num_cand": "U2FsdGVkX1+Z/ublS5yThdd5yS1RWxTtKHbrBK9oTqc=",
            "cpf": "U2FsdGVkX19WV7Kqlo+8HWd4hglA9a1DW8Py+KkuLL8="
          }, {
            "num_cand": "U2FsdGVkX1/2oE38rOtX0wsKj+hYZOlVsoerdSxhp9M=",
            "cpf": "U2FsdGVkX19OO6zVCgxA39VFy3I+6sJnI0h6VlSL7Ew="
          }, {
            "num_cand": "U2FsdGVkX19NlMSTWWI6GD65w5YvYjzOtmkG9362Cv0=",
            "cpf": "U2FsdGVkX19uu8qRo7I1WAQKTznThuG3ET+UtRQMrp4="
          }, {
            "num_cand": "U2FsdGVkX18xKtSZHAcrg/3buu38tPVk+6GHvMuBIWI=",
            "cpf": "U2FsdGVkX1/h7dC10NjHTwON+srr4czc+6us8V0ehqA="
          }, {
            "num_cand": "U2FsdGVkX1+zkU/6vuSfdtHf0qyIEm6Sr6QVB2IYhLc=",
            "cpf": "U2FsdGVkX1/eFISDwpkEbazNMfw7dgx3mYlZGHNpCr8="
          }, {
            "num_cand": "U2FsdGVkX191MFuYSMqebNOpWGjNhLqgJKzOIKf6KT4=",
            "cpf": "U2FsdGVkX1/M/Ys3v/0Fxofs3uR0PwT8g1S3TharZOc="
          }, {
            "num_cand": "U2FsdGVkX18zxe1TjVJcX+lN2uxutoyJWh8HAlimYoY=",
            "cpf": "U2FsdGVkX18Pqjb0E8iAkcKeZS8w78zOYbuOvza8g/c="
          }, {
            "num_cand": "U2FsdGVkX1/UsCVp6F9FtPrEWAPWnLN8Fy8aC+bYQdI=",
            "cpf": "U2FsdGVkX18BZyK+RL5t3L98uayrsoevdFztfAr7ZEI="
          }, {
            "num_cand": "U2FsdGVkX18E4nYXXFr509M3+UjUbCJlhqwljyOHsH8=",
            "cpf": "U2FsdGVkX18dEAFMNXVfsIbgVccGqcGsaq5Xrws+C50="
          }, {
            "num_cand": "U2FsdGVkX18xysXLkEw6Ofs0CM9UOZrtm627AHWvNOs=",
            "cpf": "U2FsdGVkX1+a0jMzm/oNtVeWWB+pzKVN72iSJOlBenE="
          }, {
            "num_cand": "U2FsdGVkX1+F0UlR+hfsmV0gTwTdsoA9LEmOybrEBxY=",
            "cpf": "U2FsdGVkX18aIh65zCV8Qvt93sEL92KdJet2FVfCScs="
          }, {
            "num_cand": "U2FsdGVkX18IhcDv4tvunZhpbQ2KWxRml//7yhl+r+8=",
            "cpf": "U2FsdGVkX1+BxGMegPrGWLu/aogZfc6gWFnsJd23EM8="
          }, {
            "num_cand": "U2FsdGVkX1/+SsuyRHWLk904HBeDg7WNIbzHgZG4P4w=",
            "cpf": "U2FsdGVkX1+0vEJELi+ba3eoO8kELBColRMPI7ufa1M="
          }, {
            "num_cand": "U2FsdGVkX1/92C8YbjDnaeGjs+y8B+r+HOcm3mt3jkc=",
            "cpf": "U2FsdGVkX1/QhYAvxR3bxnIlSMeMVCXQkfNsC/tJc/I="
          }, {
            "num_cand": "U2FsdGVkX1+GXV/aJHzaiTCm4hv2lbKTAfS8kOemuWE=",
            "cpf": "U2FsdGVkX19auw3tb/xwogrFt/I0GwXtYbm5+RuMG1o="
          }, {
            "num_cand": "U2FsdGVkX1+zAzpODBybEvtCMinoK41JSJsDecPvzZ4=",
            "cpf": "U2FsdGVkX1+toWyBxYC6igO9clC/sJaM09Xmj2WytOE="
          }, {
            "num_cand": "U2FsdGVkX18rJrVIpuCLaRH5Ibk9KAQh5AZjOpIrlTY=",
            "cpf": "U2FsdGVkX19DOUfI8XcU9NzJ90ajESSEyKDA4OdLV10="
          }, {
            "num_cand": "U2FsdGVkX19EK01wkkfiQ5X4ntY4pZersZshDTnzVBg=",
            "cpf": "U2FsdGVkX1/no1reaJLyGOTuklQ2eKBSEhChu2YhYc4="
          }, {
            "num_cand": "U2FsdGVkX18VEfvEb+ZtK+/M5JDUOwpz21YV/4EVHBw=",
            "cpf": "U2FsdGVkX18K3GDZILps90SOi+YeErKbPLUMmBOoZyY="
          }, {
            "num_cand": "U2FsdGVkX1/9f8CtsaVbKNh2hRbCra7/IUvvKA4Ss+U=",
            "cpf": "U2FsdGVkX195QLGBJfDsxR8b+J4XWEZ7YPuioE9ABVA="
          }, {
            "num_cand": "U2FsdGVkX183Kl67t8eZ1j7gozasPGigJpgJAlN6MIM=",
            "cpf": "U2FsdGVkX19jtBkjZ+h7ez9R12XjoyaURYU4hnFyw+s="
          }, {
            "num_cand": "U2FsdGVkX18/Dh4h8oosEOi5AfDvysC4QzGpu/qMl+8=",
            "cpf": "U2FsdGVkX1/4vch74lUZ1IYwEY+65TSfOo/SqwULuRo="
          }, {
            "num_cand": "U2FsdGVkX1+yy8LtbRx7Ds1CxDZkY99I9euA/WY/lqg=",
            "cpf": "U2FsdGVkX1/a6/O5O6KbiQPq9vatTOuMcRm7Aguvn3E="
          }, {
            "num_cand": "U2FsdGVkX19u1opoIuqPbqfMR9ErLsjzm26XyPMLho4=",
            "cpf": "U2FsdGVkX1+k3upoOuud6d4NDqWJrb4ON79fGGqaZSU="
          }, {
            "num_cand": "U2FsdGVkX18FYEnuNc8STPTQVvqwg6hxP41bkGlkC7w=",
            "cpf": "U2FsdGVkX192MT0vPZD3fEl2duglAvZlWlGuM4q5IfQ="
          }, {
            "num_cand": "U2FsdGVkX19YtXoflBpKwzxDgwcNVHtQl1y2FKs41Ds=",
            "cpf": "U2FsdGVkX1+WSHVApS8bOA9dV42pzhZnszup0vvr89k="
          }, {
            "num_cand": "U2FsdGVkX18/iXdO/hb1wtSFVjv49t5dgdW5hcrqfno=",
            "cpf": "U2FsdGVkX18Ul2UUYm0RuFOMYKIpfYSp3Pfs9fFBCJc="
          }, {
            "num_cand": "U2FsdGVkX1/xPQh33dYcTc4RYU+L9Vi1GyLRTo4jZZQ=",
            "cpf": "U2FsdGVkX1+LbKNiZFXSudvSpu/njOM9z2+D6pu9Hdk="
          }, {
            "num_cand": "U2FsdGVkX19ImZyevC8sxVb9rrUMn2XoyLO244BRH2M=",
            "cpf": "U2FsdGVkX1/D37vGS1380XqvsolhthB9WIViXx7W6kc="
          }, {
            "num_cand": "U2FsdGVkX1+tAU/Yw1eWfRWiXUNNufMi4sBc2AVUDsI=",
            "cpf": "U2FsdGVkX181wNHl3lz+7GOYxBHfPCrHqqayWJMTKuk="
          }, {
            "num_cand": "U2FsdGVkX19n2VY5yEmER+NB2fJax3gHEDoJHkmvQL0=",
            "cpf": "U2FsdGVkX1/HAfHGgb9OTyEBIVYkUnXKkojd9BVXkOQ="
          }, {
            "num_cand": "U2FsdGVkX1+cTVC5W89cN4WROlwU0A5w+sYm/D24AzE=",
            "cpf": "U2FsdGVkX1+9e1Kw4O710UYyzNjBG5podrYkzDD23o4="
          }, {
            "num_cand": "U2FsdGVkX19xRSfxo+dEeHA4qX/3rf9I2rVALEZw7Gg=",
            "cpf": "U2FsdGVkX1/k4PKAW0Z9aLVe577OvMyC+gDh4GIMhgg="
          }, {
            "num_cand": "U2FsdGVkX19Fb06EDZDCzaedy5iMNAb0JCSyzUOglCE=",
            "cpf": "U2FsdGVkX1+IRViHKhlMXj7FGxnt0nmC6u3o2U7+u3o="
          }, {
            "num_cand": "U2FsdGVkX18nHw31vgLuzJ9I7a84756+W1YKY16VirQ=",
            "cpf": "U2FsdGVkX1+dxhGNOedE+So2z9bqmG9O71JnZtp9084="
          }, {
            "num_cand": "U2FsdGVkX1+RoprRZ8cf/xtH4MsZ9WjpKD6uBuMDaU4=",
            "cpf": "U2FsdGVkX1+S4h/Fe9vrE92j8CFxoqDfQpAYqHHbKeU="
          }, {
            "num_cand": "U2FsdGVkX18qjNhjGcVy2kzIiqb3RRRu3MwmrwOnPIo=",
            "cpf": "U2FsdGVkX19X65f4k6ewrzWyAcJ+/Sl3k/EoAjYkR18="
          }, {
            "num_cand": "U2FsdGVkX18oFe2xgnmmAKaudQacbGZ3gc8PjzqwAro=",
            "cpf": "U2FsdGVkX1/YCBCkNKTSlHgC8EtmzcWikIGpgc/bwdE="
          }, {
            "num_cand": "U2FsdGVkX18EcLAGMndA4gIFbdEEWsxXq0jD89mxAPU=",
            "cpf": "U2FsdGVkX180kkAf+sopBM+WgoLzce9284h6Dq1JToE="
          }, {
            "num_cand": "U2FsdGVkX18eAIXERd5p6+ykeFw+K1HqTcHE71jJfzY=",
            "cpf": "U2FsdGVkX1+Y6d00nJ/QDvl3b/qdbY2MhckoQnSzTbE="
          }, {
            "num_cand": "U2FsdGVkX19k49nHSGnFCf3gCPRazc3JEgY4rC/Vt6w=",
            "cpf": "U2FsdGVkX18j1tql+GFujADiVGzriQnB47veCAAAHwc="
          }, {
            "num_cand": "U2FsdGVkX1+smD+csYsE11lEVeyP2AoUDSEvfiD3HAU=",
            "cpf": "U2FsdGVkX18M/fEn08cq0oz++igK2/dlwo2wzHXPH/o="
          }, {
            "num_cand": "U2FsdGVkX1+7fqKYLK4Taxf+zF9n1azwgfL4XIBnN8Q=",
            "cpf": "U2FsdGVkX1/a0dP78+g7k/mO6qfPmWqrmmv80V/H7Rg="
          }, {
            "num_cand": "U2FsdGVkX19AFAxXzq4g6OWxq4ylWdO0NvlF2xLgsiM=",
            "cpf": "U2FsdGVkX1+7Le5Rr/cMum0Ri9yJ77ov1RyaplR3BU8="
          }, {
            "num_cand": "U2FsdGVkX1/vwI5ApcKv2AMst50wbjzUgKuyV7W9xcY=",
            "cpf": "U2FsdGVkX19LhSc4fxQU9Dqez0VuUxBJO0gENq3a/e8="
          }, {
            "num_cand": "U2FsdGVkX18Peos1x6tyloAYTulHZML7TeCNd1TJq9A=",
            "cpf": "U2FsdGVkX19fTzs34uzyp+DVdUvw2yafKSKG6jX8RmI="
          }, {
            "num_cand": "U2FsdGVkX19TK5MiotrhYZqTYsp7sQLGVErgmQzlO0o=",
            "cpf": "U2FsdGVkX1/Xt2gC5W0HtTnru3NB+L5QyGCYo0p4HhI="
          }, {
            "num_cand": "U2FsdGVkX1+hWGi/4ohySYFzQ1/Waw2sIG8JGjfhZNI=",
            "cpf": "U2FsdGVkX183WB2ndWc19BJzd52zuinIPFhPgT8/XLU="
          }, {
            "num_cand": "U2FsdGVkX18N3AEMeQ0rmfJhKYS8UxvXIBZQyuFENbs=",
            "cpf": "U2FsdGVkX19vyUvo11C54iEN5c5CTpLYF0t+nstkBv8="
          }, {
            "num_cand": "U2FsdGVkX1+JqoPjwc3bnu0cxlqLfVRgcnRSPEnweos=",
            "cpf": "U2FsdGVkX1/uB73JWxK4ohbCNfeF6LVaOcYyaQSZc5E="
          }, {
            "num_cand": "U2FsdGVkX1/pwbbnPOqSNkt9XZp0s5cRNiuPpDnrRPg=",
            "cpf": "U2FsdGVkX194cuJj7vZ3VJb8xPz81T+KgfIaO9ZWyAc="
          }, {
            "num_cand": "U2FsdGVkX18Bq/VJPv7lUwa4G63X53CvdpBgWBE9ZeM=",
            "cpf": "U2FsdGVkX19omwtcgHACFs8LyZITG3aqhlH8ONIZWMg="
          }, {
            "num_cand": "U2FsdGVkX1+bSbopvfdRT3tNnBD8VsxArdezA5RH66c=",
            "cpf": "U2FsdGVkX18EtF+fRhCMjMeR5ceDk4H9fU81SKNgGEk="
          }, {
            "num_cand": "U2FsdGVkX18+ZoHeyBnkpNRV082ivvUab/DyruMUu/I=",
            "cpf": "U2FsdGVkX1/YgRSNClaJ27OID283BZAgOX6tcCufgRw="
          }, {
            "num_cand": "U2FsdGVkX1+CzFqd89grhAH2IJF42sYIN6buKweAUHw=",
            "cpf": "U2FsdGVkX18LVoiIVJacMoX7QZL5v4ghx80yvN7dTY8="
          }, {
            "num_cand": "U2FsdGVkX18lJrEK9whstfMzHI/tOslGvsGefnL8f3Y=",
            "cpf": "U2FsdGVkX19Oqn5hBaLQ+cRejb9R+yAAh+0pGrpgKMk="
          }, {
            "num_cand": "U2FsdGVkX1/qkmATj+tDrOvlk/UyhqAKQReeQTo+0+4=",
            "cpf": "U2FsdGVkX18a9NcbgBZR4h6EjCfpn7xIet/JwuMEHpM="
          }, {
            "num_cand": "U2FsdGVkX18H0a9dzHWCVMlcV6mELBgm4xYZBjfvQC0=",
            "cpf": "U2FsdGVkX193ITILBnu0efQkVXnJ3Mm8wfzXm18/2A0="
          }, {
            "num_cand": "U2FsdGVkX19geOEd1PHYBFZCcaKmvTxSKzLj3ZLCWk8=",
            "cpf": "U2FsdGVkX195c1xRa1JrQdhpBlzCzg3vqwK6yAOLdvI="
          }, {
            "num_cand": "U2FsdGVkX19BzmO0NN67HkPYgC/0YuaFGzVXA4cV160=",
            "cpf": "U2FsdGVkX1/HqHNGm7A58zT5/HUCFOLbyl1zfz8SjQ8="
          }, {
            "num_cand": "U2FsdGVkX1/fyHUSI+I6lagThNOdxIgVbVZSGBrTObY=",
            "cpf": "U2FsdGVkX1+eRMeTY0l+iAA8O+7KpMHVw3nd/EXPN7o="
          }, {
            "num_cand": "U2FsdGVkX19lwFiBB64B/4E+LyzBOCZsLUH2KOzD/kI=",
            "cpf": "U2FsdGVkX1+rBfE3DKkLGySD9MlYjJu17cXS/lcDijg="
          }, {
            "num_cand": "U2FsdGVkX19cQHpy5hTsxliVMDQOHu4tci7b6LSyqfE=",
            "cpf": "U2FsdGVkX19aMvHWBq5mBfoKdt/flx0INpEi3iJTZHg="
          }, {
            "num_cand": "U2FsdGVkX18DUWO89ES1d5ACMIOZgZYANaIvL0+sdi4=",
            "cpf": "U2FsdGVkX18Q9sxJiGsIlc3LupF3rc5TSs7dFftF5Eo="
          }, {
            "num_cand": "U2FsdGVkX18YY6QIg5Emyh9uQI546bAitkWwIppoz94=",
            "cpf": "U2FsdGVkX19eIIHd/B3WlmrUNiS5Nzn5ds6+6wUKqB0="
          }, {
            "num_cand": "U2FsdGVkX1+1SzYem7hqBqbOEPSvSyi+VEINGEWURyM=",
            "cpf": "U2FsdGVkX19AIM4w4L6L0HcVODkqWZCo4sIEaGJYp+I="
          }, {
            "num_cand": "U2FsdGVkX18a+khFachkSt5B2woardXykdtfmaIdR1k=",
            "cpf": "U2FsdGVkX1+qz5s7/shw3GfqW8CXWJbx2Epk/tD09Pg="
          }, {
            "num_cand": "U2FsdGVkX18nJleo7iejd98Qpe6I+/pxRXnWBBId7SM=",
            "cpf": "U2FsdGVkX1+fvGqoQQKjVIfL0dk3VXNKL6YuVl/3KA8="
          }, {
            "num_cand": "U2FsdGVkX184XMvcJt45kMuZ4Q93qxXfriX25ho9f5U=",
            "cpf": "U2FsdGVkX185zw1qn9IyIDbEdTk+pHcESfnm9xhcymQ="
          }, {
            "num_cand": "U2FsdGVkX1/Fa0ps8mXDqE9nHxh3dux4VngvIZI+osQ=",
            "cpf": "U2FsdGVkX1/hDf1ARvKCD2uNufGGMyvvUr2wH6mr7Zg="
          }, {
            "num_cand": "U2FsdGVkX1+2wmMwNTkyv+nvx8Qe39ZkzQrpPY1Li/M=",
            "cpf": "U2FsdGVkX19vhOvjCGP8PWet5utoImd0gUDAG6eWi0Y="
          }, {
            "num_cand": "U2FsdGVkX1+zwf0rEa2/khLiCrdMVRNzIV/sxFWbXnc=",
            "cpf": "U2FsdGVkX18/JiWcJeH2U2biYtKg8up4aBnR/EhTzkw="
          }, {
            "num_cand": "U2FsdGVkX1/6quWW3jIATNTp5bFzWXHi2ovTuRYYP18=",
            "cpf": "U2FsdGVkX19pgmwi/6NcUwOpeazMAFpWyUSbauMtBPg="
          }, {
            "num_cand": "U2FsdGVkX19bgCbFHKZFUgFN/kfzso/MBsgw3JEApbk=",
            "cpf": "U2FsdGVkX1+uYGfDfHG16qySghpXcKMW+ZVLREV4KYU="
          }, {
            "num_cand": "U2FsdGVkX19z45HG71BNESOb4xPPN1hTJw16Pf4Gkeg=",
            "cpf": "U2FsdGVkX19zvStxTL8kDrXVp8w02dPIeEPtVo+JN9A="
          }, {
            "num_cand": "U2FsdGVkX1918e72iZMBRYlEq2EZ88BSN1AqvbsEpV0=",
            "cpf": "U2FsdGVkX1+QjFZmRl1nbqUfdnBhtMmEKZS2RGNeIiE="
          }, {
            "num_cand": "U2FsdGVkX1+gDkTWWcXdPjhqEkqX05R0KP2iKzCp9WY=",
            "cpf": "U2FsdGVkX1+TE2Ql1yeqEoOoJEDfkC5/COXExZK8dnY="
          }, {
            "num_cand": "U2FsdGVkX191HOmwlzscf99FrEhYZK8v7F31IClzabk=",
            "cpf": "U2FsdGVkX1+aiYDrmiDPa/0nhqhv0Bx/KxVFcFk4KLI="
          }, {
            "num_cand": "U2FsdGVkX18YU6PL8d3TOzqA12avefV6ZdPRv4+vIPI=",
            "cpf": "U2FsdGVkX1/VeTQkYKVhEZ/r1LWM3n3QVMzUVxFB9z0="
          }, {
            "num_cand": "U2FsdGVkX19oEOV4XcRq//KaxiAohpdHw45aoG7KTbQ=",
            "cpf": "U2FsdGVkX18VproaiG99nkR9wwdf+eeD4DqzqUGckpE="
          }, {
            "num_cand": "U2FsdGVkX19/L1I68fkBML9VjJCDf5Eb/Yej1fEFLzw=",
            "cpf": "U2FsdGVkX18RPGv+maD3H3b9Eqy0edeuMqSzUNeyFE0="
          }, {
            "num_cand": "U2FsdGVkX1+u40IrOlbmkVEt8kHW1T3sspjqZwD85lw=",
            "cpf": "U2FsdGVkX18PSU0F0E+C3u9bVYJRmCFvU2cgtkqcW7Q="
          }, {
            "num_cand": "U2FsdGVkX19SHY8nuzqfVmtKMsEu0BDKpTZlcfEOd/s=",
            "cpf": "U2FsdGVkX1+pde+IVwtLTU8FoXsTT26eOY9HCGSuY8w="
          }, {
            "num_cand": "U2FsdGVkX19sWCURv7631lW2gxd5KjOqofEnjIARmS8=",
            "cpf": "U2FsdGVkX1/cuOYXUR3P25gGbBtK0YVjULl4Bgm6nWM="
          }, {
            "num_cand": "U2FsdGVkX19tYAaqYvwZrO+DZZO1ycM2Isyg/zFo14Y=",
            "cpf": "U2FsdGVkX1/T8FOY588HQZJ/0y9fOKepukDKklQq7/Y="
          }, {
            "num_cand": "U2FsdGVkX1+130Fo8Qe0pAz+NMKGvTBOBTYFxdK6l08=",
            "cpf": "U2FsdGVkX1+tGjBLZzjB0OMcjX2tC90lcgPSo2jJlvw="
          }, {
            "num_cand": "U2FsdGVkX18daSfTh/bDymVMJrlzsAVr9TytsifJDd4=",
            "cpf": "U2FsdGVkX1+pBQVpM7ipVmAeNg0fVBqeiaFwd140ByI="
          }, {
            "num_cand": "U2FsdGVkX1/pEha8mWAS3J4o5eqqGo+tHTN7WnkR+Cs=",
            "cpf": "U2FsdGVkX18r9nRUGzBvCYk/k9mrfJ0Ngt5/ca6tUGQ="
          }, {
            "num_cand": "U2FsdGVkX1/N+VBlCAF+eh+Y90lcBW/Hg9ehkYz3tLg=",
            "cpf": "U2FsdGVkX183KxD7eSlY+Skb7eUbTG//JHDeg7yV2BM="
          }, {
            "num_cand": "U2FsdGVkX18Y1zig07xUElFg0W3MMgKdS5maq+lw7Xc=",
            "cpf": "U2FsdGVkX1+uILj15oxuti4dghbYuaIzgAJ40F5gyCI="
          }, {
            "num_cand": "U2FsdGVkX182SPmAS7hJSWqFj5WSXiAp5Wt8MPdDTjo=",
            "cpf": "U2FsdGVkX1+06oIOpMhuOtNVG3lQ1euQPt4IT7pdyoM="
          }, {
            "num_cand": "U2FsdGVkX1/UGqTdUrjJG/GpmzxcG9hoU8C5qmwJiyY=",
            "cpf": "U2FsdGVkX19JiMyL+ZPy/uGtj19omk8qQ80TQHASwmU="
          }, {
            "num_cand": "U2FsdGVkX1+8mrvjl9x3kyMdRvxxDvd9GT4X9Rlua5U=",
            "cpf": "U2FsdGVkX19BL4A96oOGDbWVGNS8gy6E9YX6OADefrc="
          }, {
            "num_cand": "U2FsdGVkX198ardmMrwW+7glyo4FCs5zm2KZRHa7Y5c=",
            "cpf": "U2FsdGVkX1+hie8ZZg3k0mNLBAN3TMMFITmc6LAEIwo="
          }, {
            "num_cand": "U2FsdGVkX19vXU4Jm77F0C5P3NpkNMzgtv/AGj9bdD4=",
            "cpf": "U2FsdGVkX1+INg1lZgYT+bDXZedCXhuvecWV46jCLCY="
          }, {
            "num_cand": "U2FsdGVkX1+i0BoDeh/BZUts3oRoRMadSuqB3iCHbLY=",
            "cpf": "U2FsdGVkX1+8cBW+/O8jOvBL154TRimr8NW/yO1ykCE="
          }, {
            "num_cand": "U2FsdGVkX1+7104z51PTez/HKvMqbxAu9zlGS5BC0aw=",
            "cpf": "U2FsdGVkX18M6ypHNnN9xU1APi0qKKsp6choG4Qpi58="
          }, {
            "num_cand": "U2FsdGVkX1+dymTBgbJIAgBvsxk2KipstYQJv4CzIaI=",
            "cpf": "U2FsdGVkX196YaOXq+iX1Qn/BR/8Evvar3XIdGmYas0="
          }, {
            "num_cand": "U2FsdGVkX1/fqtQ4UdbAM86Wk+FvjQrrcokFL6y8ptk=",
            "cpf": "U2FsdGVkX184O9Z7iR0jKo5D8ycZh6FkmatBLkVRbT4="
          }, {
            "num_cand": "U2FsdGVkX18YCpfawdN/IQOWX9l36pN4Q1oZbNUEczE=",
            "cpf": "U2FsdGVkX1+uHuLFC608Is+nTYVTqzfbWzpw9UTECM8="
          }, {
            "num_cand": "U2FsdGVkX1/iUwdRj7k7/Mw4u3S0QwfnEqWyQJEq/fs=",
            "cpf": "U2FsdGVkX1+W7N7KLdf5sY6jqEzswWr8hVZcWTGqPK8="
          }, {
            "num_cand": "U2FsdGVkX1+aQYEQ8L1Epif9EvNVVC6jeeECGND5hHs=",
            "cpf": "U2FsdGVkX1961RIHcEZBBrsk7dMYg7mL4HwbC/KF4bY="
          }, {
            "num_cand": "U2FsdGVkX19QODShHLYHZ3bTT9KOs3pJy8f62tdTbj0=",
            "cpf": "U2FsdGVkX18b8e6ZHf8FJfBZFDkzOAF/vXv6zXMvbus="
          }, {
            "num_cand": "U2FsdGVkX1/1LSWZfYsYbgD5sTHKsT9KBZhjsCuvB1Q=",
            "cpf": "U2FsdGVkX19a0MGnkcIYha/ao1Di8fKZYesIDhzT+Dg="
          }, {
            "num_cand": "U2FsdGVkX19uHmuiGa6clNRCoI32W/yzq5JK0ymo2WY=",
            "cpf": "U2FsdGVkX19GT2ABJKOLVQbUYTP1rxwSmcQ27OZh/IU="
          }, {
            "num_cand": "U2FsdGVkX19imrrmafj84++9S/iwYiIZgwvB0tf7Zog=",
            "cpf": "U2FsdGVkX1/ArHIlGgSxs4qDHn20TWpRW/uzx18M3P4="
          }, {
            "num_cand": "U2FsdGVkX18f5GHt1+IN0AmSsR1orO5mTr0ZtVtLnMg=",
            "cpf": "U2FsdGVkX1+cFAwP9s/sXrfsDTxdjuHnuisB6GNAlRk="
          }, {
            "num_cand": "U2FsdGVkX18IosR+5qO+5yiFPf39H4R8x/gnOCTGHUs=",
            "cpf": "U2FsdGVkX18rZSp6f7oq+/6z9u61JIyEd0lDsveUDkE="
          }, {
            "num_cand": "U2FsdGVkX18Vpqq2e+cwfZT3PAvdrFTnS2IEBGq2RT0=",
            "cpf": "U2FsdGVkX1+blKw+Z7REgvUVXk7NcC0p/rqUEGMokvg="
          }, {
            "num_cand": "U2FsdGVkX191Ut3wFK/q7PdKCgljZ0uVdcEl51HMbSI=",
            "cpf": "U2FsdGVkX18L5MNheiZUWTaD7rIHI8zig3SIja12x9k="
          }, {
            "num_cand": "U2FsdGVkX1+KQ/eDBgQ+Uu1p81NIDU1XUT3rT1xwjOM=",
            "cpf": "U2FsdGVkX18JJCsR11UIoxjNOxQYRrJ3dl4xJLa42Do="
          }, {
            "num_cand": "U2FsdGVkX19zTb8VTz0YYumjpXb+Mu2tgRe38+asaVk=",
            "cpf": "U2FsdGVkX1/KjUwF0RU8UD6R99XQp75jpz5tx6rSyAk="
          }, {
            "num_cand": "U2FsdGVkX18TtXKGfAvrAFib1iRp1rI7ZOCH4IHhv0A=",
            "cpf": "U2FsdGVkX1+2SMQheDPymggwNNtbkPKYtv4mnv7aM9Q="
          }, {
            "num_cand": "U2FsdGVkX18up3WVgD/7t2yEHtmKD+d8EWE05lYbap4=",
            "cpf": "U2FsdGVkX18BU0xqTXBPa28iMHVtiuM/3puqngMMOMk="
          }, {
            "num_cand": "U2FsdGVkX19OjLocizNpZdHIRv8QJqyWV5R8toiJXIw=",
            "cpf": "U2FsdGVkX19Tgk7ow17TC/thBwlQXTtCiPZwaznLQI0="
          }, {
            "num_cand": "U2FsdGVkX1/7pe7IKuhcHgYbd+XTTtW0h6YT+IyRbqM=",
            "cpf": "U2FsdGVkX1+z1f+UEUxZCTTtNevO9u4TBhchWCZgqT0="
          }, {
            "num_cand": "U2FsdGVkX1+JvZAI/jY7jPngm0DAd6IR63W4V2ANr5Q=",
            "cpf": "U2FsdGVkX1/q64Zg59geirZ8pYAqOMKitNaq/Ektc58="
          }, {
            "num_cand": "U2FsdGVkX18R1a1Yn5kQYPBsK4LHZgPDtC987Cua96M=",
            "cpf": "U2FsdGVkX1/MZF+lmT83YKUkLDJZ4CpdQ57xblGU3Nk="
          }, {
            "num_cand": "U2FsdGVkX1/8MaKz+HN/dHK10F2QZ5sWY/2W6AOFbag=",
            "cpf": "U2FsdGVkX19ij4Si78MTphXLC5FG9UP9EOok+4QWnHc="
          }, {
            "num_cand": "U2FsdGVkX199Y2JPxwjFDULc/Gx9Qcwr2LBALMGSCKA=",
            "cpf": "U2FsdGVkX1/ffiKgJ1ZIrfj0f6dEjejUUuI2j0dm+/U="
          }, {
            "num_cand": "U2FsdGVkX1/qFrpbbAdCcvxwENzTx/S0e91ePdr84EA=",
            "cpf": "U2FsdGVkX1/vjSH/yIFuw+sSIRKgxN+b4KSp0sUS1ds="
          }, {
            "num_cand": "U2FsdGVkX195AjhAyqnNQjqFDBE1e8gcEVC3v7yI354=",
            "cpf": "U2FsdGVkX19TQ8kTR1iXV0kpYMVfKpzwrx+/RHutvy8="
          }, {
            "num_cand": "U2FsdGVkX19UCr+bf0fpxVCp3tyyV7sOutcMHn5tArU=",
            "cpf": "U2FsdGVkX19T9jIpPfSaCQHErHPuDaaC5yelXumXcJ4="
          }, {
            "num_cand": "U2FsdGVkX19ULjd6WEX1NCmGriseLRtKCUXT6VKtHVw=",
            "cpf": "U2FsdGVkX19ItOb783xwGZE42FtoO+5sYHWg0faz9wQ="
          }, {
            "num_cand": "U2FsdGVkX1/IjReeSXpfPQiEJyi/cPINwsGl4c4harE=",
            "cpf": "U2FsdGVkX18V5WhuB+D9c/ab3USgDzdmmjuzWpaNNu0="
          }, {
            "num_cand": "U2FsdGVkX18FGTFYjcIw/TIMQ/+MnkKkVMYm9MJMJgw=",
            "cpf": "U2FsdGVkX1+kBI21UkO+FyGKO8//fWBy3OiVcRDbQ3Y="
          }, {
            "num_cand": "U2FsdGVkX1/TYCnqP/h1SM81oSXHQoKt48pmuKQktyk=",
            "cpf": "U2FsdGVkX1+iuRaVpbStOLDnA/rGw1yzs2hOUsiJT6w="
          }, {
            "num_cand": "U2FsdGVkX19CJryQe9vsNV+cSlZHufP3QoGN/6IXVZs=",
            "cpf": "U2FsdGVkX19TwvpzyY5nZkf5bxq2HHWtjJzk7NCo8wQ="
          }, {
            "num_cand": "U2FsdGVkX18nJVjx0YlxYnBnjlKugILv7vAkyYp1oek=",
            "cpf": "U2FsdGVkX192b3EA7pjaW7IkI7haWs1sMGtv3OAWKYo="
          }, {
            "num_cand": "U2FsdGVkX18NVCx7eNKZFqfbpu2C/v+3DHwNc4yTAgY=",
            "cpf": "U2FsdGVkX1+QZLjmhlI9+RsuZc/bRxaN/nX18Unsp50="
          }, {
            "num_cand": "U2FsdGVkX1+AcHHVRJA2Z9/osOjPVkigSLR9PJ9rFDE=",
            "cpf": "U2FsdGVkX1+iPY3wdGMk6sDwMKomLD6V1ZaaG4P6K4g="
          }, {
            "num_cand": "U2FsdGVkX18ovFE2Pv4gAatOZwsIkKdV8uc+vstQnxk=",
            "cpf": "U2FsdGVkX1+lRB3vhMp6DsmZblHkDZL6yUOHMQfrx1k="
          }, {
            "num_cand": "U2FsdGVkX1/4hgax2ITSrksd0xEpIAOG6cJApEDTuxE=",
            "cpf": "U2FsdGVkX1/jgSx8EW+XmA5FF9seX7BLkcp7L+3b1t8="
          }, {
            "num_cand": "U2FsdGVkX1/PeiIjS7eAhSXnRSVHg8Ww3HTRD8HGJuI=",
            "cpf": "U2FsdGVkX1+cPbktfXsUXVALwo+NviHVMzRDRrUcgJc="
          }, {
            "num_cand": "U2FsdGVkX1/uglh+Zqbr3FlpgksxLDFPC7eM1XsVjek=",
            "cpf": "U2FsdGVkX19lNcFI2AtrZQUb9I5KEBJ/SdD9D9wkunM="
          }, {
            "num_cand": "U2FsdGVkX1+fk9dBStEzaWz52wyHA1eMr32RTOLocHc=",
            "cpf": "U2FsdGVkX1/Yt1S5AWeXQkGByePrJLnNR8M1PNMt7pg="
          }, {
            "num_cand": "U2FsdGVkX1/JOsnzTW30VEc7nc+k7xpwpAF82byHoJU=",
            "cpf": "U2FsdGVkX1+zgAdlAqsdPJzq6lMjTRCQAsM8+iiru7g="
          }, {
            "num_cand": "U2FsdGVkX1+q9KjkxLK7uJltraMI0ofsCeumLdtAq+0=",
            "cpf": "U2FsdGVkX1+W+odW0qKseOJ4IM8P3i8VynAfijd96ow="
          }, {
            "num_cand": "U2FsdGVkX1/+568Rtu5u6H7csW4OKPI7uoh5BvvtWuk=",
            "cpf": "U2FsdGVkX1/4JnfAWTHvGjBlrvh0JOWdzbGoj9pa8sc="
          }, {
            "num_cand": "U2FsdGVkX18GNFI65cy+dn0kMlgp6e3dbMd5NKv07IQ=",
            "cpf": "U2FsdGVkX18VU/Qf2zlZ9BXKJoPoHI0p2VAUj9pI49o="
          }, {
            "num_cand": "U2FsdGVkX1/vtdQY/I6sJKblvGphQIB9ond9CVUDxcs=",
            "cpf": "U2FsdGVkX18Dyo7CaW57qxg1/IkinaPIzLmIEQpnpOc="
          }, {
            "num_cand": "U2FsdGVkX1+5XuIJpxHU5q1//6pAMn1XEIUfF92ymGU=",
            "cpf": "U2FsdGVkX1+250nyK3gxlq1emyB4m5x5qnBQWYfNuNY="
          }, {
            "num_cand": "U2FsdGVkX1+ObwK/U0blW05I1Ub53r2+GYup9n6tLAs=",
            "cpf": "U2FsdGVkX1+eaXhewCkL1wA9qGgsM+O9IMwiO+/m7JQ="
          }, {
            "num_cand": "U2FsdGVkX18lbdLKwmlol4ezSfYNzg7QQzpYKzSW1e0=",
            "cpf": "U2FsdGVkX1+Qjkeg3ROhl8sfj/8VguGLrZwlyiSknl0="
          }, {
            "num_cand": "U2FsdGVkX1+nXKgaZg5GqQkX1c86IO1QmoBrnOR9s00=",
            "cpf": "U2FsdGVkX183FxVKtIkyI77Pa97pH0qgz3wAQiN/bvM="
          }, {
            "num_cand": "U2FsdGVkX1/URJo5IpaTHVEhynmCtaT6tnXxUoJ+DY8=",
            "cpf": "U2FsdGVkX1/7zQEAx1vT60FjirtUV8ql80OMK2XXWys="
          }, {
            "num_cand": "U2FsdGVkX1/S+c/snE9eb4SBJwiKvmBDboofs2e/aDA=",
            "cpf": "U2FsdGVkX196FpbZ8k/mN/12zDXN3T3sfdmNmiT6W5g="
          }, {
            "num_cand": "U2FsdGVkX19iEc09gi+BpBFkb13SZsRsHA85cYRPwxk=",
            "cpf": "U2FsdGVkX1+791YK3ZwLN2nJdF/2K6qt+GHbqnEWSBs="
          }, {
            "num_cand": "U2FsdGVkX19e3fyLiEOERMJysaOSfcmr7rDsSBDzGFo=",
            "cpf": "U2FsdGVkX19xzb63wvrEAsps8Ygt42IlK/62J8KJHlM="
          }, {
            "num_cand": "U2FsdGVkX1+J8rvmNsOhuFv00dbrCVNcX3wv+njGUxs=",
            "cpf": "U2FsdGVkX1/JaHHWp5PAZFlRd0lwcrEX0jDV2c8eosg="
          }, {
            "num_cand": "U2FsdGVkX189tmfncB5/wjXHcfi29LWcrr6i34IkqTA=",
            "cpf": "U2FsdGVkX18OI2f79I1O9j8/gvVqXJ4qIxGC2+yENVQ="
          }, {
            "num_cand": "U2FsdGVkX18n/a3Rk/mgp5cRCKq2SH5K/rEJkmDwASs=",
            "cpf": "U2FsdGVkX18NMsRPBoYr2gAgrMOZB0hot+wg7CyU8mg="
          }, {
            "num_cand": "U2FsdGVkX1+XC5f946Feyn4/05ws7oZbUNQkFZtlLiw=",
            "cpf": "U2FsdGVkX1+lC9ndaLW1wP8XOppycUsksznamKVQEeI="
          }, {
            "num_cand": "U2FsdGVkX19UpInBjnzQRJG0g6rRqAqjNFpJ0gYDBz4=",
            "cpf": "U2FsdGVkX1/TMnLevQDDj1Xt256/5KJ+agAv9pyYHCw="
          }, {
            "num_cand": "U2FsdGVkX1+3SC0/89yu6h72Jo70XY11s5FPsDwJXFY=",
            "cpf": "U2FsdGVkX1+wBcw+eai772fKukS0PNA14rMh8nv75zw="
          }, {
            "num_cand": "U2FsdGVkX1+bpkcfrHBrJy4LlMOAbk/lkWEkAkKiuzU=",
            "cpf": "U2FsdGVkX19luRWWVM0tQsA1l6aZghGDw7wAgkUGOlw="
          }, {
            "num_cand": "U2FsdGVkX19GvL/gLWCEk9ZYz2SCNgM518OLwBTlRlw=",
            "cpf": "U2FsdGVkX18I0gBzEDzIBSD/8Fn5Ksi3RjOCIhuD2a0="
          }, {
            "num_cand": "U2FsdGVkX1/HptT92oQlJaFgTl5l2RsA4jxG0UZtrQs=",
            "cpf": "U2FsdGVkX18pD66q4FgBn5iRj9ARm+wo4DQLYswVoeM="
          }, {
            "num_cand": "U2FsdGVkX19IuxFnQbfO4iK7JbjAmv1O1F33QuxaaPk=",
            "cpf": "U2FsdGVkX18qgo6HfPBD9pIdq4D68BAdtUisMtvdxew="
          }, {
            "num_cand": "U2FsdGVkX1+SRujEZ1T1OifN2fNT0slc7F5gLdVIkFU=",
            "cpf": "U2FsdGVkX1/eh3izjGVUEJzaKR8tFxgIw2rkzKKe9J8="
          }, {
            "num_cand": "U2FsdGVkX191m/CRpXC9KRcR3G3AOp+5Hogx2hU6QD4=",
            "cpf": "U2FsdGVkX19+8ZmHjLytyAYuaiIZkbfh/3kwGiORpTc="
          }, {
            "num_cand": "U2FsdGVkX1/SmTDdHItM3Y+aHO4R437b3qS+Mbi2Cfo=",
            "cpf": "U2FsdGVkX19aWfT/RxhCfDDtnpfXITcObeqH2FddiIw="
          }, {
            "num_cand": "U2FsdGVkX18Gp8GcttEeJVivTZvn2+jqo17SyQ5ml1k=",
            "cpf": "U2FsdGVkX19O8xR6oYRErADaqxmmfcNGyIKpqSOpoew="
          }, {
            "num_cand": "U2FsdGVkX18I8qBeYjARjLzYz9PiAdqefX5lV+XEK5Q=",
            "cpf": "U2FsdGVkX1/PZkq/UrEMWrksm7cqMxyQu9pfBEgZYGM="
          }, {
            "num_cand": "U2FsdGVkX1+OQRdH9vsrRovjQmmj5ayDYS006daYLCI=",
            "cpf": "U2FsdGVkX1+nV/WkdokqR1pX7dh9Js10DbRX4FZgezw="
          }, {
            "num_cand": "U2FsdGVkX1+yspwW8Ma/DlOofuj1G89FwaF+QfHUfhk=",
            "cpf": "U2FsdGVkX193CYCbvL/5GOVvS2zyoXDYsb2TdChlxuM="
          }, {
            "num_cand": "U2FsdGVkX1860wYR5BJU2QAdlegRjPpcFag6PUdjQk4=",
            "cpf": "U2FsdGVkX18Qxnnlp241ieX/e8KpyBdprqAKIa/kOGw="
          }, {
            "num_cand": "U2FsdGVkX19O1Jkvbnu/QBU4CmhO3iebLQOluJYULf4=",
            "cpf": "U2FsdGVkX1+wvJsoxZrTncawHqvQzckltoZP15I5ai4="
          }, {
            "num_cand": "U2FsdGVkX1/2pCyo4XLM+H/N8DIczQkaRYOytzXh330=",
            "cpf": "U2FsdGVkX1/5VwzzhYbobLtXmMZyCQZcCiHbcz/KYac="
          }, {
            "num_cand": "U2FsdGVkX1/wWMps8/EdvZEViSmMhf4GCb19TjGLsIk=",
            "cpf": "U2FsdGVkX1+OCBoygVsB7+EkbCEyIVCb4RI/N53w9aU="
          }, {
            "num_cand": "U2FsdGVkX1/OQMwfR6u/W8BMEMFUgCa8scZqZLaXHJI=",
            "cpf": "U2FsdGVkX1+/u8PECJq4joW9ooBTxH/kpFXl+AQP/WQ="
          }, {
            "num_cand": "U2FsdGVkX1+YYsoorPGMdF8nNnFe/TakOMfcZekc4E8=",
            "cpf": "U2FsdGVkX1+fbes0W5F79TI5o8AO7UTIQ7o6jp3gzfc="
          }, {
            "num_cand": "U2FsdGVkX19IGPquuef0jM73LsRF4q9vKlPNRNUBOk0=",
            "cpf": "U2FsdGVkX18I1/wRvmdBk6YUnAkKU54vmKyoCwLA4vo="
          }, {
            "num_cand": "U2FsdGVkX18p3Bt68k28bLeOjao8UUVCguf0aYtFdqo=",
            "cpf": "U2FsdGVkX19KgnFznHI2lCUJDbOKQY2YZ1SkNwvY3Ag="
          }, {
            "num_cand": "U2FsdGVkX186ptqGpaTnKedze6Er56Pkou2SNcePN6c=",
            "cpf": "U2FsdGVkX1/gUpApUpRKWQUwhrVgSao1HpRkGSSVgGo="
          }, {
            "num_cand": "U2FsdGVkX19c0Wgkyh9/KETODejUjf6+z4r1rYxAbBs=",
            "cpf": "U2FsdGVkX185IlcqtdkEyTw3uCxMwnU3Bm/akN3ly8s="
          }, {
            "num_cand": "U2FsdGVkX1/JRJinLKh58JdhTfLwJHI3bGFdePYccLc=",
            "cpf": "U2FsdGVkX1+Mqe1iJ2ahQW6/5YdfiLPgMPlFc58IEmE="
          }, {
            "num_cand": "U2FsdGVkX19APA5xggibycU5s+E+7Ne8L/mJA/X/FiA=",
            "cpf": "U2FsdGVkX1/0Seipn6oSoWjaiFYOLTOReLiFE+CTxz8="
          }, {
            "num_cand": "U2FsdGVkX18YDn00PCtuTBN/tHoiUILfQ913F9UiPRI=",
            "cpf": "U2FsdGVkX18sbFHZ3DFQYipyds8aPO3PYo5MHk33IsY="
          }, {
            "num_cand": "U2FsdGVkX18dptg+kipa8nfo2S0bRSqYDUznYCKbPgg=",
            "cpf": "U2FsdGVkX1/gsUPt0U+VRZh/hSCDCCGRzbnW6pNmS7k="
          }, {
            "num_cand": "U2FsdGVkX1/MmFYEQM7B7zWUaY3UNp00nhA4xyRHJbo=",
            "cpf": "U2FsdGVkX1+nHg/Jj3KFEwZkmFeCcJRkD1H6EocH484="
          }, {
            "num_cand": "U2FsdGVkX1/okbYJBCkY86xCvXavowJZyzNQ1CWkYUg=",
            "cpf": "U2FsdGVkX19PNSyHvuhJqE89oCe4qcft7xnMzyTuOZk="
          }, {
            "num_cand": "U2FsdGVkX1/Ijb6nr1JRdc/vhNUaFIur1Yfza41t37g=",
            "cpf": "U2FsdGVkX19nMRyRfdPXejSIemkBxdd1a9J5jrWwbCQ="
          }, {
            "num_cand": "U2FsdGVkX1/U+TFw2wue+Mwz01DlXXM5FX7AAX58ONc=",
            "cpf": "U2FsdGVkX1/xiKaKHxhTz35r2bvrze9QfbvcjAksyWU="
          }, {
            "num_cand": "U2FsdGVkX18HvdZ2j00Po1MV/e0BWTCUbXkT2BEhVWE=",
            "cpf": "U2FsdGVkX1/27P58ShPmRIEeDzVoDPtJxB3KSwVWJQg="
          }, {
            "num_cand": "U2FsdGVkX18QmLzubDI4NztL++qBwhE6tuZeUnDxy00=",
            "cpf": "U2FsdGVkX18OUokmBOTvC52rFXatFrRbdJtpFBfGBTc="
          }, {
            "num_cand": "U2FsdGVkX18SkRXe1A0lAMV9RpBSe4D628mBXpaI8+c=",
            "cpf": "U2FsdGVkX19rzSsn/cWgHCmk6ephAHlyrysRgO24QjE="
          }, {
            "num_cand": "U2FsdGVkX19AS4JtvO75NrKYSmSZMGQBwAhvRvN82fg=",
            "cpf": "U2FsdGVkX18uXUsI3GXHoIpjyUQ3OQERlqoT8u8vCGg="
          }, {
            "num_cand": "U2FsdGVkX19C0hWjnDq2bItmly6ENLgYa4s+Vb9B4Jk=",
            "cpf": "U2FsdGVkX18dOgc0chAN35gij307UsOIXmvWBrF0gC8="
          }, {
            "num_cand": "U2FsdGVkX1+8idAAn8NIxB6c+O3SM7YAfk2JCzZki7M=",
            "cpf": "U2FsdGVkX1+cPPr5axwKzBpn+J3ZGVpBbx9t9LS28XU="
          }, {
            "num_cand": "U2FsdGVkX1/c+8dHvF74eWm4ftH4Huqk7japWKb/iz4=",
            "cpf": "U2FsdGVkX19/4ZL62xs0i2lpxGAh5y64e9vcjuxRYvw="
          }, {
            "num_cand": "U2FsdGVkX19F4k6jH+BcsOIE47YpG2v34phfhO94kVU=",
            "cpf": "U2FsdGVkX19UPgmxSPXnruPirkf6V2uLvHGfjIrNngM="
          }, {
            "num_cand": "U2FsdGVkX1+BoyrGO1sy9hY7mCAA0MSUYWie71YLnBs=",
            "cpf": "U2FsdGVkX1/VHtg4XESzEqWeE8h1nxzfFeMG//0kZz4="
          }, {
            "num_cand": "U2FsdGVkX1/C/2lZ+jkJtYUpM2OgWS9C+RKfs+vktDM=",
            "cpf": "U2FsdGVkX19NRaQujEPg9g2l+9TV01mVJV/4icLYAkE="
          }, {
            "num_cand": "U2FsdGVkX18zQr+Yw94np7LveF1EV7zRRTYU4QZK62s=",
            "cpf": "U2FsdGVkX1+O6X/M4nKBBgrJq8khAgUzc4F3yP7TTKI="
          }, {
            "num_cand": "U2FsdGVkX1/YsgS7bJ1MdITZfWJOrYkFl9LRUcCg5VQ=",
            "cpf": "U2FsdGVkX1/vC5K6Hu22hfYPoLf4NmAnxR87aHBmR8U="
          }, {
            "num_cand": "U2FsdGVkX18q9l3qIxN4rIVsch5mbKCL14ub/3Cu2EU=",
            "cpf": "U2FsdGVkX19XugVmuRvNFNydCctoOedGmcx6Aamj4dw="
          }, {
            "num_cand": "U2FsdGVkX18xvZEV5izANACHzRZLiu0DUR0/6vb8XTU=",
            "cpf": "U2FsdGVkX1+6ppvrtPYOfbwM98rfBAyhhSOr9jnEGJI="
          }, {
            "num_cand": "U2FsdGVkX1+mjaBE0ntEzMDjWhLwHTfdi70Rl2Le6D4=",
            "cpf": "U2FsdGVkX1+X5TKTuMVNZE773BEvUuQoF2UGvFPa9ao="
          }, {
            "num_cand": "U2FsdGVkX1/iEZnz3/qVlT5ESkjh/sPGlYjC/NSLir0=",
            "cpf": "U2FsdGVkX18KGPwsemj/OB366oB1xLPPS/8i8J60MIM="
          }, {
            "num_cand": "U2FsdGVkX18nQarm6UB3eDFEsycwIffEpQCO2EGzYTw=",
            "cpf": "U2FsdGVkX18IDapziGBR6LrbrihIE8EpexLc+jKcFh4="
          }, {
            "num_cand": "U2FsdGVkX19pqiYqZbzrun4y7EQgLtM7KPXUtNlbgMc=",
            "cpf": "U2FsdGVkX1+Hc7cdgfdWT5Qx0iARtNScKwfgDEK7W/k="
          }, {
            "num_cand": "U2FsdGVkX18hO+YGlF4k0hYwK34rFeCEJX2Ur6EMhzk=",
            "cpf": "U2FsdGVkX19Pv1P0tBbh6ATxxkVQflJTeq4HFFyDgsQ="
          }, {
            "num_cand": "U2FsdGVkX1/GELKSmMRetQTS6golBTsRC44DTOnSktQ=",
            "cpf": "U2FsdGVkX193meXBr9pihTvg1LG8L+KhqdM5vcQS3SY="
          }, {
            "num_cand": "U2FsdGVkX19avtjMxcKi5YWfdqEx4tjxnb+mEcQViTM=",
            "cpf": "U2FsdGVkX18hVQGANJZrU44hffxLUizNtIdKTYxy8kk="
          }, {
            "num_cand": "U2FsdGVkX1/rXHRKaQmfv6j+RC1Uk9gQurnqH+T06NI=",
            "cpf": "U2FsdGVkX1/D1d4KB3x5q+AuMS3Z4VN2PegX/UnMPJY="
          }, {
            "num_cand": "U2FsdGVkX18oX8E3/+uZcYXfmho5PiZV3YE6tC5zs8E=",
            "cpf": "U2FsdGVkX1/MyhAgYYHW/BvU095gbEj2QbkuIIu0CFU="
          }, {
            "num_cand": "U2FsdGVkX18u28DbIZCKzeiruZX4y5BB6lKX22psxTQ=",
            "cpf": "U2FsdGVkX186rr8gBHdj+YoqPIz06XIkrRbYSN8OeDc="
          }, {
            "num_cand": "U2FsdGVkX19/rCR5bwyHs3gGIjyvv74Ib+eSYbpeAAU=",
            "cpf": "U2FsdGVkX1/r6s+88yB2F+5LCnC0kLYwx6gpgcNgLnM="
          }, {
            "num_cand": "U2FsdGVkX19w91etWZhbrqb4dCVvIh+UTtRTdpTXxX4=",
            "cpf": "U2FsdGVkX1/yc0QzsQnHAdMmXJR0rRZkD81yvOCoJZs="
          }, {
            "num_cand": "U2FsdGVkX18VAORCfMok3LA5iXT/jqLTk8g340bJ3dI=",
            "cpf": "U2FsdGVkX19KMTyVWfVqVUcgJ2n8a1efneDQ+JIVVos="
          }, {
            "num_cand": "U2FsdGVkX1/jDIrO8T5tI4qnYE6ItB6lwDYaiPYkBX0=",
            "cpf": "U2FsdGVkX1+40TcfaZU1LWmYJ508MeObkC/tlH56898="
          }, {
            "num_cand": "U2FsdGVkX1/7pBm42BTmhfmcs1g2dEMSRfYW8OnEOz4=",
            "cpf": "U2FsdGVkX19yKDS0a/M3zxLeHnO7uqrMbM6SHwQAyrc="
          }, {
            "num_cand": "U2FsdGVkX19OuF4wVLE8gjWJlnjdFeizNJUwrVuE6+w=",
            "cpf": "U2FsdGVkX18fEFVorwmi4ZfSDQBGg9FvXOXhbXNKZZU="
          }, {
            "num_cand": "U2FsdGVkX19Y7mGaUTLqJxWcKYyd7I1XFbsCHE799bc=",
            "cpf": "U2FsdGVkX19oDF0rGL6tUs6nmJCZEH6HAVR67sB9j6I="
          }, {
            "num_cand": "U2FsdGVkX1+62qqnE+FpAZv8XdI3b+1pMH448ejUz3A=",
            "cpf": "U2FsdGVkX19U92iOgMxdR340s7eHRV/4ZKN3HLvMvJM="
          }, {
            "num_cand": "U2FsdGVkX1+RiVedeWeGBz7fxDDRS/FQ7BdrnWa1gyM=",
            "cpf": "U2FsdGVkX1/Qo6SwcBklf75gRU026Wq2doyF+Rmcyxc="
          }, {
            "num_cand": "U2FsdGVkX18A+RGNTLMiWv7QeVKJME4C+moFs9SL+Po=",
            "cpf": "U2FsdGVkX18FZBYe/EuiVcyWN1XVb8uyteGBJfhdLYU="
          }, {
            "num_cand": "U2FsdGVkX198GozdEJG5dDXtYBvFEmD9RwpmuCUQauk=",
            "cpf": "U2FsdGVkX1+HbbXgs6Cyw9c3CLlQPW2i+iIbl8NAkIQ="
          }, {
            "num_cand": "U2FsdGVkX1/M9a3a0xb/iehTjB7az94SYUKFOKIfs5M=",
            "cpf": "U2FsdGVkX1+sFKhwRWChvMyGEG8tGBSeWhCJFtD9QYA="
          }, {
            "num_cand": "U2FsdGVkX1/B6PSzlHMRJfWu02QB0xpfE9OPoKjfl58=",
            "cpf": "U2FsdGVkX193xv0jMqdsQjnhSGNP4Jv7UK1/3mSjsiE="
          }, {
            "num_cand": "U2FsdGVkX1/l+5bC8+JnZrkH6etzLK4UjoRvBlBdOms=",
            "cpf": "U2FsdGVkX19kCMFbSAlEjDamVLzScY45xyzZkLJ/FCE="
          }, {
            "num_cand": "U2FsdGVkX19hvn4lFzHCrdYGloj6JokEbDPzpLSAJSc=",
            "cpf": "U2FsdGVkX194X8IhQX9OPg/54rnxSsITYBxlWCeSb0M="
          }, {
            "num_cand": "U2FsdGVkX18r+o7wWOdnD3FytUQlkOD4eio5rm4q5hI=",
            "cpf": "U2FsdGVkX1/lpX4BL8pgZd0MP3Ri2Tr31Ud8VuI/3eY="
          }, {
            "num_cand": "U2FsdGVkX18dMiz6IEXRQv6gDfkrglGZ5ykGiIs7Co8=",
            "cpf": "U2FsdGVkX1/eDkc/dUchbJiJLWyBMsiNMQ5ukHL/owI="
          }, {
            "num_cand": "U2FsdGVkX187eyl5b1WSjn3hib84CXsUA4HS52qe82E=",
            "cpf": "U2FsdGVkX1+0jrN57GLpWwFgTBGh6a4CZyrVGDCUfZg="
          }, {
            "num_cand": "U2FsdGVkX19nlVtldt8wc+nXUP6hN9NJlecjZSwkXsc=",
            "cpf": "U2FsdGVkX19FR1EPHTmVaXumcl792j4jpxH9oSVS1/o="
          }, {
            "num_cand": "U2FsdGVkX18rCdH0fJLYrNwBwznweub+KQLp2X9Antg=",
            "cpf": "U2FsdGVkX18NxhzTyvGrUU+BTTs/xNvjwbRXrsAZ9rA="
          }, {
            "num_cand": "U2FsdGVkX1+Ei9yQ8G4t2On+Dbo3GJIL7Pk1IVQx/y4=",
            "cpf": "U2FsdGVkX18CU76lGqvMAaEnY5qEn9wwlyIfePzcE6E="
          }, {
            "num_cand": "U2FsdGVkX1/LP0tEErav343+RirOwmrFnvo78orR9bM=",
            "cpf": "U2FsdGVkX19Bu2E4fxW037/k7uBT3kjaztE4qCrll5Y="
          }, {
            "num_cand": "U2FsdGVkX19A4nWPc1ZIHugzWrQhzduv36C44vsbt7U=",
            "cpf": "U2FsdGVkX1/Q0/470DSsbMXNVuh9Cz8SE1HjHIZGBiI="
          }, {
            "num_cand": "U2FsdGVkX19oam0iRtMqGPYR1QxmWodHAVHxki+VAxI=",
            "cpf": "U2FsdGVkX18JCVboqhsj3u4yI9KWa44O9QaIv8w/cFE="
          }, {
            "num_cand": "U2FsdGVkX1/qyt7oC10LuJL0UboEZN7HYvM5z2UsMbM=",
            "cpf": "U2FsdGVkX18VQF2KRBTNFz218PhJ7nhx5wmmqoX+/Kk="
          }, {
            "num_cand": "U2FsdGVkX1+7KZrqSJuB8Ep/Rj8zHHWLce1JeLXEv34=",
            "cpf": "U2FsdGVkX18p/ZbGH4DtIfC9+8tn9Tx0DZRp1Dmj8go="
          }, {
            "num_cand": "U2FsdGVkX18ii09rq6uioHwIQaCE4HyUZ010arOZC/w=",
            "cpf": "U2FsdGVkX19jfggKhy0K4uX5VXXAtn064knQhXaGoUM="
          }, {
            "num_cand": "U2FsdGVkX18sGozXSnaZ7ZzyIwwZnPh9HVhbjW3WMb0=",
            "cpf": "U2FsdGVkX18m19M17TTWrQ7paVjbkrRHkFrjCdNf9DY="
          }, {
            "num_cand": "U2FsdGVkX1/JlX7N7sSS5nnC0zrye5/hsyUmrb4Xwjc=",
            "cpf": "U2FsdGVkX18DF4oXWYjpp92JJMJMc5q3SM+mL6tWK6c="
          }, {
            "num_cand": "U2FsdGVkX1/b/ca85HOLz+EUBFoV5Iudn7T/iLwmTDk=",
            "cpf": "U2FsdGVkX19/vfkh4gNgRDEnV+enxY+lIpaC4sDE36U="
          }, {
            "num_cand": "U2FsdGVkX19lPhUuHtTY4OvYAk94dw7wTzSsIAvm8QM=",
            "cpf": "U2FsdGVkX19ojlK+vxm43ozePaxzOx14H9nWQKOEuig="
          }, {
            "num_cand": "U2FsdGVkX1+pMe7s21TsKbCys8qBvvDswldqNjy1tbg=",
            "cpf": "U2FsdGVkX1/qgrsSrLht6ZHvHTWvd/giWqSVwNahRU8="
          }, {
            "num_cand": "U2FsdGVkX1/+s7PwzCP9+tVh0xyXLfvuB/tmLUOPfAc=",
            "cpf": "U2FsdGVkX1+CPdOrE8+O5skFX+h74Ah2JO7kmSgPFt8="
          }, {
            "num_cand": "U2FsdGVkX1+LSchRKZKMi212cGamsMad2/7QXjInurU=",
            "cpf": "U2FsdGVkX1+meXIX4PYcPYV+FwKjRe1bq0VhB7MZYwY="
          }, {
            "num_cand": "U2FsdGVkX18nhCLGgZIf7wDgNS1T1lfIfTaDXPMAXKM=",
            "cpf": "U2FsdGVkX1+0bRhdMJ3giSu9xDBV2HGKybFUFdzrkHE="
          }, {
            "num_cand": "U2FsdGVkX197EU999ekz0jGdLftQHlUQs3MACWXaMlg=",
            "cpf": "U2FsdGVkX1+kMVplaTbT7II2R4mqx16a4SqTWC0DGew="
          }, {
            "num_cand": "U2FsdGVkX18ghrpQju9/d77viTPDYfti7ulTG6pbg2k=",
            "cpf": "U2FsdGVkX19Ta9JhIlKzOBXLVUdPyoLxe1CrMUsQMiY="
          }, {
            "num_cand": "U2FsdGVkX1+W4dFieowrC3YGriVdk5EXxqaWtXaw6Vs=",
            "cpf": "U2FsdGVkX19GRrYhs8whqS01zBpoLnVTJ89qdvn/n2M="
          }, {
            "num_cand": "U2FsdGVkX187YvA15buJvTM42T/1iiXZmwtH2tLrD8o=",
            "cpf": "U2FsdGVkX1+sX5CqBrY15gpIwtN4+moD3F2JoDz8yGs="
          }, {
            "num_cand": "U2FsdGVkX1/oePTVGDHHAU1hAx8W2J3teKPf8EBUHpI=",
            "cpf": "U2FsdGVkX18iZ8n7JslqWc+VFOjWXIvz6filrUTQmVY="
          }, {
            "num_cand": "U2FsdGVkX19Zzb7BK/w6xfCD0FiR/yVu4mghcSxYlnk=",
            "cpf": "U2FsdGVkX1+SwPsszckGt3TEFmL/E61oUXRIyhUJs8o="
          }, {
            "num_cand": "U2FsdGVkX18n5awCwVeN6to/FZiCnCQeT7lk20awbvM=",
            "cpf": "U2FsdGVkX1+aWqGMX5ENt2t0A+/8km1BlgwQqHBTBDk="
          }, {
            "num_cand": "U2FsdGVkX1+0sEsl6qClw1AvR9VklVDTAz+vA04TWe4=",
            "cpf": "U2FsdGVkX1+9YzVPp85txknQzviNSYiKxfK0rDc/eQc="
          }, {
            "num_cand": "U2FsdGVkX1+4wboF06jIYSqIBZfWZgbNCnEucQws7fU=",
            "cpf": "U2FsdGVkX18zDdgXsxWi7zurgBJ5GzrPTkwZYZjrm10="
          }, {
            "num_cand": "U2FsdGVkX1/frlV8jvYlnfUV9Bg54glC2IQdc/RVTcY=",
            "cpf": "U2FsdGVkX19BmlmP5TBsjzmFXn8fs8gG3QGCjcrDlCc="
          }, {
            "num_cand": "U2FsdGVkX1+pEOdNH7R+vwb6XxMtv3KIZe9sczzt0E8=",
            "cpf": "U2FsdGVkX18AQzG3aFz29kBdModOBxnFI4lwNiasDuE="
          }, {
            "num_cand": "U2FsdGVkX1/2EvkXThpy2p4kaGlYnfb0naJC/CKl7Gw=",
            "cpf": "U2FsdGVkX18GzSGVydj7MEMmd3tQp+yPijlNn+E/NUk="
          }, {
            "num_cand": "U2FsdGVkX18Re4bGDvc1VQA5BI9+QWHaQRbCEri03ps=",
            "cpf": "U2FsdGVkX1+D4LNOQzJzf9w5pUSayhR6u/m1Cg6VM6k="
          }, {
            "num_cand": "U2FsdGVkX191oY5x89o56TP84qvlLDXR87wCw1CkV64=",
            "cpf": "U2FsdGVkX19R+I3F8PanfUxTzmWgBcoGTDpXgdJXG4k="
          }, {
            "num_cand": "U2FsdGVkX1/rMI0v4hi3fCRBDvBBwdXH46dPkArkyxs=",
            "cpf": "U2FsdGVkX19BZIYckcXDF0nbKMTMaVrtOJEYsPDqqAU="
          }, {
            "num_cand": "U2FsdGVkX1/lmNyfdottHnuc94um/GrUGMigQ6eTkNQ=",
            "cpf": "U2FsdGVkX18ccW23njHFkw+djn+fUKAs65iy03a35r0="
          }, {
            "num_cand": "U2FsdGVkX1/42FwvwM0+Qi66hARoGLif5NI2erj/O8I=",
            "cpf": "U2FsdGVkX18KRxQfLh41BD+2lLkS0I5uGiFhOCd6/JA="
          }, {
            "num_cand": "U2FsdGVkX1+AI+8sIoCLDn4H/NnEFCbKIMmyUkbtxzo=",
            "cpf": "U2FsdGVkX1/7wLWtmx5lfsZoORoV+toeu/HqSRYvyl8="
          }, {
            "num_cand": "U2FsdGVkX1/rtOncnLgGpqKM5WSJiILn3hv+xzJRgOM=",
            "cpf": "U2FsdGVkX18D+QIV2DSHvFD4XvJ4+ypXeNn3SdmYNso="
          }, {
            "num_cand": "U2FsdGVkX1/wjYsy3Oz3yDOthduj7WBxWOoK1QSztm4=",
            "cpf": "U2FsdGVkX18R1qTduB1CSpDVma3Dd8GOTBngjsHhEHQ="
          }, {
            "num_cand": "U2FsdGVkX1+1TESTLgzKnMpF0TetwPV8huQDAr2GxXM=",
            "cpf": "U2FsdGVkX19Jgvh1124D+uPY15A2+rWYtyMrGJqNAyo="
          }, {
            "num_cand": "U2FsdGVkX186Ll7TCQFQa1XDjP6MdMn2VprHrdg0Gi0=",
            "cpf": "U2FsdGVkX1+V50f+mMVslordYMEdoWQBhVsxffVEs+o="
          }, {
            "num_cand": "U2FsdGVkX1+g13b5+V97xf4Qs+S6rJFw0Meg12BoqnE=",
            "cpf": "U2FsdGVkX1+wm6FO82zSgUWcRZUfck8ubDTseRDniXQ="
          }, {
            "num_cand": "U2FsdGVkX1/7yRK/opkosiDG72iDJBnyoqLS1Uxb0Ns=",
            "cpf": "U2FsdGVkX19T0sUiie1FEOBBLTE9LErm29fnSwBhrn4="
          }, {
            "num_cand": "U2FsdGVkX1/FqortKj64xEskHyamIrTdlRlmeoQ1Jg0=",
            "cpf": "U2FsdGVkX19RZLjuOYb5dTzJSW/ya2uWEEBLD7RS9Ac="
          }, {
            "num_cand": "U2FsdGVkX1//7MLzgulhh1sccu9xpdx2cMYBBB2l6nw=",
            "cpf": "U2FsdGVkX1+OMoLG+izQhwSLigJWkBp/zFNh6e9jNP0="
          }, {
            "num_cand": "U2FsdGVkX1+4S6vjtsTaHAajWHCl2Dz1aMMzotGY+Fw=",
            "cpf": "U2FsdGVkX1/DhouERTgLndWTTRL+7X7Xvsm52fN15Ug="
          }, {
            "num_cand": "U2FsdGVkX1/HcMBEFVd1rKAFz9OG0Jdd33KPpUgRIFQ=",
            "cpf": "U2FsdGVkX19GLyEQj5PxbtGwgJdZa2ZALPymu4VjC3g="
          }, {
            "num_cand": "U2FsdGVkX181hMWvnRkVrj3I4uwPLE5fzx87iNQmlB4=",
            "cpf": "U2FsdGVkX1/+FxEg9WJh5dmKyGx6MrkraBpACM+sNkE="
          }, {
            "num_cand": "U2FsdGVkX18YLnfN9eZf8VwZ2+4yLioOTDN+RI/0N3U=",
            "cpf": "U2FsdGVkX18rYI7POMJuyDHlgY2XOmi7zTjBN7B/nTE="
          }, {
            "num_cand": "U2FsdGVkX1+PcyPwVFwKS2Xh6uqT5lyibm1QFnQz9NU=",
            "cpf": "U2FsdGVkX1+Wawo0LMgqCs97YpBz4NwtqVWvSr3gtJA="
          }, {
            "num_cand": "U2FsdGVkX1/cjANdZ6D1WL9Es/yMOdg4Qtj1i6Fdoik=",
            "cpf": "U2FsdGVkX18w/J5kq/tCmEnMX2eSByeOZcQHtjCN8KM="
          }, {
            "num_cand": "U2FsdGVkX1/LHKvvldO8Ji3+a6nUXMrYSVT4RwayvAc=",
            "cpf": "U2FsdGVkX1/ELemiOb1dp29idpy7+HhMmndydPHHaLU="
          }, {
            "num_cand": "U2FsdGVkX1/Kn4XY7bFdRAo0tbD5p1qIerhb61CmVR4=",
            "cpf": "U2FsdGVkX1878Eyum8el24rgqsy1BCMtB6LqLvEvIXU="
          }, {
            "num_cand": "U2FsdGVkX19VwsKK0TMI5RyYkM7hK7uEYujNz/KD+24=",
            "cpf": "U2FsdGVkX1900wBmBTEmSTA6pI0rLwJIgPdPUv0yMGg="
          }, {
            "num_cand": "U2FsdGVkX19Duk8ghLV4AFS99eLoNlLyZ7WKS52JjNU=",
            "cpf": "U2FsdGVkX18qjx8U7cK5+HOqsYp1YKkoWv88SUwtQ60="
          }, {
            "num_cand": "U2FsdGVkX1/493XtLOYiw4y//Ju9AOYjuCuozMvBqVU=",
            "cpf": "U2FsdGVkX194Btu8DpTp949arKiJQLuIUuvRzpIGh+c="
          }, {
            "num_cand": "U2FsdGVkX19ta8Sl8Z9Hp/G5U6K6pBbydTMCeasCeKY=",
            "cpf": "U2FsdGVkX18EZwbM/yKWbHITR2txq9e1Ukbtxd4W5+g="
          }, {
            "num_cand": "U2FsdGVkX1+e+HAOVcEgDfQJlt434WRn33bSFnz+3C4=",
            "cpf": "U2FsdGVkX19wTqv8IC5XIXRI8JFGVcxysq37jZHpXp4="
          }, {
            "num_cand": "U2FsdGVkX1/gafn1yZZD668d3hCBW438P91R6TVKHHk=",
            "cpf": "U2FsdGVkX18bW1421jjzmNHgZWuHa2JvYdAiAhRbID0="
          }, {
            "num_cand": "U2FsdGVkX19ztVeAwMoPopN1Fj3Fvuo094erS5rMTKc=",
            "cpf": "U2FsdGVkX1/yQ4MAPCkD4w1M4VWwx1EwoXO8iF+hcec="
          }, {
            "num_cand": "U2FsdGVkX1+cgfwMPEu21IPPTRlyXMscLVh2Nes1ekc=",
            "cpf": "U2FsdGVkX181GTa31EP0UbfITfjSluxIU9+JgJnBjZc="
          }, {
            "num_cand": "U2FsdGVkX1/MoRXRFYMKhdZuFUW5GsASDc1wbRhRrAI=",
            "cpf": "U2FsdGVkX1+5wChtBkHo6OQAGYSZ7SDphrgHNYAisv4="
          }, {
            "num_cand": "U2FsdGVkX1/vjlVKOPc4lSoTQEHy8Qv5dnDre6oyprI=",
            "cpf": "U2FsdGVkX1/oFD4krYU8HwFSVSjMrnZcSEwW/Wki+mw="
          }, {
            "num_cand": "U2FsdGVkX1+giKOrnZ4eXzyZlgJ0jxqkOo/O3ww31G4=",
            "cpf": "U2FsdGVkX19A/2WoVmCBKMeaKirZEqyfDY9dpi5RLEk="
          }, {
            "num_cand": "U2FsdGVkX18TJ2lFlDA8E1plSE7sPm94UeAjopIJ0GY=",
            "cpf": "U2FsdGVkX19H0wsqpivCcw/c33B5VZ7iOpwl7ytZjhc="
          }, {
            "num_cand": "U2FsdGVkX19+lAOjtlSeW8FHTmDimG3cw2gT9c7l3Ks=",
            "cpf": "U2FsdGVkX1+b1glzAV1LCPC7n5RQD0h1VLCr4K2+yH4="
          }, {
            "num_cand": "U2FsdGVkX1/x84Vzd1+aWDLD7z9ZGlmXFtq54l++2GU=",
            "cpf": "U2FsdGVkX19nEEWA2GYHrbV2jwqqCjUPOypPb9vtZdQ="
          }, {
            "num_cand": "U2FsdGVkX19J+YfXIXlGgieNowZOn4eZj7GWni5I1hU=",
            "cpf": "U2FsdGVkX19EYMIJOsl81q1wKqWMthki83q2gA3L3rw="
          }, {
            "num_cand": "U2FsdGVkX19rUSKw3b5t+z8oKbGzv6xbgGD84FIct1s=",
            "cpf": "U2FsdGVkX1+CBQWfIZfoV5/AcCbmxwuazrdd/OaA8zY="
          }, {
            "num_cand": "U2FsdGVkX19VWfM/pJZuakP3z7Ga1HhYkIKhljjRA/8=",
            "cpf": "U2FsdGVkX19Frp61REeTk/wh5lf3CdTnjH8jxAw7Hgs="
          }, {
            "num_cand": "U2FsdGVkX18phqmwkKaFGPCJpyy+/BHFdZcBFGx2if0=",
            "cpf": "U2FsdGVkX1+WT61DsG9vCsWzefKBr/Q5tNQfu4lJPeM="
          }, {
            "num_cand": "U2FsdGVkX1/9N4lrFuspwVh8TqY7ia4SLULfPRo3rio=",
            "cpf": "U2FsdGVkX1/1/qHWbxJbbRlPFijwVZIeLjhaM2KYus8="
          }, {
            "num_cand": "U2FsdGVkX191mXZrCahqZrEHNMucWZtg34xArbb21Js=",
            "cpf": "U2FsdGVkX18l1doF6P0Q1pM4utAbHiSm12QXQJ9hmfE="
          }, {
            "num_cand": "U2FsdGVkX1/coL4HiNEWf09fNE16XNjIxNPdUXqvzww=",
            "cpf": "U2FsdGVkX1/PRZWYIjBMe1zwQqzoqEALYN6r8aLeIaw="
          }, {
            "num_cand": "U2FsdGVkX182khTHNGI1GejV/ttaZdmoYhEWAhMZNOw=",
            "cpf": "U2FsdGVkX1+jYhnHIHUWBFux/9B7Wnu3orDbvFNDy7E="
          }, {
            "num_cand": "U2FsdGVkX1/FOHwM/Z9MkJBwutgwDKgwU2gWDDkvnDQ=",
            "cpf": "U2FsdGVkX1/dpYJ9ZTIkxCBCCXbmkKlJhuSreqsX4Kw="
          }, {
            "num_cand": "U2FsdGVkX1+B75MXo4zogL0j1HxqjOliHSjcuI9k2Ks=",
            "cpf": "U2FsdGVkX1+9pM065HVkt7W+UXpuUelgWFdtCOL33qQ="
          }, {
            "num_cand": "U2FsdGVkX1+3QtaBXzXzW7OjRO/xYj9QRYgSeVEcG2c=",
            "cpf": "U2FsdGVkX199GLGfYckNLxOm0HrMbH/ht7KSD1ohKho="
          }, {
            "num_cand": "U2FsdGVkX19MFeEs8Xbu2NS5NrD7XP+2h3UquhLON7A=",
            "cpf": "U2FsdGVkX19S38+k1cA6BtFcRQ5Gi2bkofagKFtRrsQ="
          }, {
            "num_cand": "U2FsdGVkX1+1gELLy2zIpYnfyrsUF/QNEgI1+HME7g4=",
            "cpf": "U2FsdGVkX18GmxYMtH5/McEupVOTTVVfu+1FwMt1hmM="
          }, {
            "num_cand": "U2FsdGVkX1+wD5j/9nsoZM1DQOpc3o1tkSVkP3zNPb0=",
            "cpf": "U2FsdGVkX1/AAnNF7gVwJtVwr2c95nXbVOuBaO9FR8c="
          }, {
            "num_cand": "U2FsdGVkX18x2GBaNued9UMvtLHB9pqfpqb+uEzh/bc=",
            "cpf": "U2FsdGVkX19vzpjmKPrNKN7WvomZDtn++2hv5MgozV4="
          }, {
            "num_cand": "U2FsdGVkX18O55UZSLInNJf5XNi3EbWVOuZhkk/7+2A=",
            "cpf": "U2FsdGVkX19UOjdp3arP2K8rBakcLLtAy0m0BkMdZKc="
          }, {
            "num_cand": "U2FsdGVkX1/Fl7gazK1pP7aMcIcOaBDr+boVRQWYtdo=",
            "cpf": "U2FsdGVkX1+b1NXmGdVktMeQIIpRQ5YgnKSwxwPidQc="
          }, {
            "num_cand": "U2FsdGVkX1+Jb1064mIGWwp31yVy2jrfc21sCii0AEU=",
            "cpf": "U2FsdGVkX19Eq4sHnT0Gh0yfk8kfn3/oEbu/I2gCkkg="
          }, {
            "num_cand": "U2FsdGVkX1/Owav4vxFN80V4W52EKnC2Y8H5TXQIgTY=",
            "cpf": "U2FsdGVkX1+YhRfbcYcTV6kuRDzj7IjQMCC5xOkNlQI="
          }, {
            "num_cand": "U2FsdGVkX1+piFI006pngO0RTmOh3RBc3/NjvJzVhGQ=",
            "cpf": "U2FsdGVkX1/QA7b6VH/fVMeukfqlEw3FkTKaJZp+60k="
          }, {
            "num_cand": "U2FsdGVkX1+GIsIBJDqpZCx0UJoV8mbbuBQ2IDxqdQc=",
            "cpf": "U2FsdGVkX1/plAHdp7CzNsE69z3QAkVjLxUvqdRPDrw="
          }, {
            "num_cand": "U2FsdGVkX19kdfPyYasqNVtfnfVhGfQNek4vxjIY/Qg=",
            "cpf": "U2FsdGVkX1+VguJ8wafLcZF+yHq1SFT8bpIvADagMcI="
          }, {
            "num_cand": "U2FsdGVkX1+u61WlNvYFVE7b6qwIg/DbL8/ORrIlHd0=",
            "cpf": "U2FsdGVkX191qq6NRoRV33/E/b3tjXQDp4sWBXUS5sY="
          }, {
            "num_cand": "U2FsdGVkX19530ZCHCK8IN9Qbuk9IpASKlL9l1ZnZpA=",
            "cpf": "U2FsdGVkX182m2tQnGlxsFdaPXEap3udPnrc0MG5IN8="
          }, {
            "num_cand": "U2FsdGVkX1984I/aqOrEQRZVpfrhpuJEgHICHoG+QBU=",
            "cpf": "U2FsdGVkX18QajREZXB89my/Ot4uQos7/z7AyZUW5/s="
          }, {
            "num_cand": "U2FsdGVkX19ocu38P8xovMIGt4D1H686g0YYSx8J5I4=",
            "cpf": "U2FsdGVkX1+ZXc7/75HvbNlGkZ1AOp916ODv98z6ydk="
          }, {
            "num_cand": "U2FsdGVkX19NQ4IJJogLu6RCCDRy+DFSYLUi5ie4SBs=",
            "cpf": "U2FsdGVkX186tEko0mWm37VegIS6r+pG9dRY6yFdTws="
          }, {
            "num_cand": "U2FsdGVkX19FRNxvlYVQU7DM66s5O/4bYpj6jwq295c=",
            "cpf": "U2FsdGVkX19MHBBNt7o1zAt2pkl3IX/z80xmmCOmuAo="
          }, {
            "num_cand": "U2FsdGVkX1+V6pgQ34CAVzZ/HM+iUK4a2JGcanHj7LQ=",
            "cpf": "U2FsdGVkX1+LG2ZtbtmAe5GKdHoNaBbIMvn+pNil3a8="
          }, {
            "num_cand": "U2FsdGVkX19MxL4mmL9K3rF8hJWHKeur+intSeIDioY=",
            "cpf": "U2FsdGVkX19R4U1kPEM223PLmD9zw5JgaPzHN1t58KY="
          }, {
            "num_cand": "U2FsdGVkX1/vVHcWEHyi+zgduaAj2D4g/5KrbiTjJZQ=",
            "cpf": "U2FsdGVkX1+LUZ2cq5QuqMjIf8afQfQaSYXrqxD7rxY="
          }, {
            "num_cand": "U2FsdGVkX1+Rf4V2Hs+CMRI1uRX7/0TzR5sMCg4Tt3M=",
            "cpf": "U2FsdGVkX196q7L5koLLS9wg/fOcXYPjHgVEGeKf898="
          }, {
            "num_cand": "U2FsdGVkX18epXpk7pGz7zh/fcuDuyljEY5DHM34pqk=",
            "cpf": "U2FsdGVkX1+REIv5L0ReBcN6dW7nePoG3hy9aKhEcY4="
          }, {
            "num_cand": "U2FsdGVkX18TAnnFfqAhMgMnxDNRtZWoyiVUIWb4SWg=",
            "cpf": "U2FsdGVkX1/b7lSXWau6L3bdhJYmKmaqlDMvdDevE/I="
          }, {
            "num_cand": "U2FsdGVkX1/V5OO10vSo0DHPuFC7VALcWxXMKu1U87s=",
            "cpf": "U2FsdGVkX1+fuVQH+8QOEfUBL3CPlxxVjWkeR8xy5b0="
          }, {
            "num_cand": "U2FsdGVkX18GEq7audFJm/5WilromX935dTSGeYmBTs=",
            "cpf": "U2FsdGVkX1/b78SHtaqIEJjT4Z1xQSdFyV8Pu5gup/c="
          }, {
            "num_cand": "U2FsdGVkX19ls0Zr2/YxUraFtLRVpk2FYtgvHyoKC+k=",
            "cpf": "U2FsdGVkX18khUKFp7AYyUDmAMk+nKNsTBwnjGMze20="
          }, {
            "num_cand": "U2FsdGVkX1+SDosrjVKejd4LTRJntRdiLoqLzzYN0QI=",
            "cpf": "U2FsdGVkX180GcFtx9SBRKXOZxcGnMOVrra7Z/Xh7xg="
          }, {
            "num_cand": "U2FsdGVkX18kA3JAzWQnh2+miPy4V6yEpYMCQu6szQo=",
            "cpf": "U2FsdGVkX1/QayvlTbc/x0yxK02830PeGDa/+H1AHLw="
          }, {
            "num_cand": "U2FsdGVkX1/Rm9COH1run4laMEyPcKU6QDl5k8I9P2k=",
            "cpf": "U2FsdGVkX1+X7RF44Iyto9c65QuSw6MkrvCXX89rFM0="
          }, {
            "num_cand": "U2FsdGVkX1+meWZ9nXW1ApSbMaYjKdmtt6YbXWpbHlY=",
            "cpf": "U2FsdGVkX19hgBoOWebbSlpCZSbbBxkoTlHIApS7vT4="
          }, {
            "num_cand": "U2FsdGVkX18DfUo2BK8Id3pzVyjm9ZB1wnu18+K4hDg=",
            "cpf": "U2FsdGVkX1/nDTnTcAYEjfy0/S6zDRjwcBayi08TQtg="
          }, {
            "num_cand": "U2FsdGVkX1+020es782g781EhFy7zgoQxnZ9zOw2U4E=",
            "cpf": "U2FsdGVkX19sEYWPiwo0F3ztpvcE2zfjeSWhZVvK+Lg="
          }, {
            "num_cand": "U2FsdGVkX18MpxawcKz+9LclhfNzsSn35WB+9XWx3Sg=",
            "cpf": "U2FsdGVkX19Y92kD/5n/Ld4KApVdIHOhUnnLVTOdLxI="
          }, {
            "num_cand": "U2FsdGVkX19j7clu26VynptoMJ5JnQ11kMpW8x14/Vw=",
            "cpf": "U2FsdGVkX1+3A9nhi8yGQbDBHe2HdWRsxboL/jYcEi8="
          }, {
            "num_cand": "U2FsdGVkX1/xpT1dfFLZ+lXi2vy7BXGjzwUHiT7A4CM=",
            "cpf": "U2FsdGVkX18lmk73nENsNMnhc9ksNNOjioqud0oDFEA="
          }, {
            "num_cand": "U2FsdGVkX18ewKX/U/GDiO+19n0XGQILSQuAAKFWC2k=",
            "cpf": "U2FsdGVkX1/MnUr27QS13Uwtg8PFGisBoI0RHo3eiQw="
          }, {
            "num_cand": "U2FsdGVkX1+b/zKldjd4TaSbuHDhTwbUZIYFJdPajoc=",
            "cpf": "U2FsdGVkX18nOOvSr6idDG0HwHGtu9FM6tEnFrt5az4="
          }, {
            "num_cand": "U2FsdGVkX1+MdIOErCjAKLaXT/86v/Vw3WG8fN2h/rQ=",
            "cpf": "U2FsdGVkX18hhN1lLPUhjJ+ZfPHkfHmYJTI6f4gL0dQ="
          }, {
            "num_cand": "U2FsdGVkX1+gp9RZFfFkMDFI6MrCQIm1wD285wT0s3Y=",
            "cpf": "U2FsdGVkX1/RdNZB4BkRpMCXcVVt7C84Ys0iZCbOzvU="
          }, {
            "num_cand": "U2FsdGVkX18ZGrAiRqxDcNjkMId5ebu5yn+UQlURFwo=",
            "cpf": "U2FsdGVkX19DcBPpZD/mX5IWTgmrF2qst8PNLb+S90Q="
          }, {
            "num_cand": "U2FsdGVkX1+nRRW9KwR6c81lK8XBrrMp9LJretJpvQk=",
            "cpf": "U2FsdGVkX1/zmVGd54opBpbL+1WlFq/HHTPA0eLGpvc="
          }, {
            "num_cand": "U2FsdGVkX18OAQ9TBnMUV2EbemTA91icnbCBdEKIXv8=",
            "cpf": "U2FsdGVkX1/DU/5sZcqDZLxi0YyBKsdXpnx1BCzq2Ao="
          }, {
            "num_cand": "U2FsdGVkX18cIc02QCnetjoDxf6kC785c7ovnYHeRYM=",
            "cpf": "U2FsdGVkX1/T+JKGp78sMdaUspvyi+SMBMY5q01y6Tc="
          }, {
            "num_cand": "U2FsdGVkX1/FP0vsvR7150uUNidb19WkjigIY/bcolA=",
            "cpf": "U2FsdGVkX18Mr3AVNIzqjvyNwWydqnwNLp2GSeARdh0="
          }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/not_disc_def/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
